<template>
  <div class="chat-page">
    <header class="chat-page-header">
      <div>
        <h1 class="mt-2 text-3xl text-gray-900">Chat</h1>
        <p class="mt-2 max-w-2xl text-sm text-gray-500">Gerencie as conversas com os clientes, responda dúvidas, envie arquivos e muito mais.</p>
      </div>

      <div class="chat-header-actions">
        <button
          type="button"
          @click="$modal.show('iniciarConversa')"
          class="chat-new-conversation-button flex h-11 w-full items-center justify-center gap-2 rounded-xl border border-gray-200 bg-white px-5 font-medium text-gray-700 shadow-sm transition hover:shadow-md sm:w-auto"
        >
          <heroicon name="plus-circle" class="h-6 w-6 text-green-600" style="fill: currentColor" />
          <span class="text-sm font-medium text-gray-700">Nova conversa</span>
        </button>
        <div class="chat-stat-card">
          <span>Chat</span>
          <strong>{{ totalChats }}</strong>
        </div>
        <div class="chat-stat-card chat-stat-card--pending">
          <span>Sem resposta</span>
          <strong>{{ semRespostas }}</strong>
        </div>
        <div class="chat-stat-card chat-stat-card--answered">
          <span>Respondidas</span>
          <strong>{{ respondidas }}</strong>
        </div>
      </div>
    </header>

    <div class="chat-layout">
      <aside class="chat-sidebar-shell" :class="hiddenMenu ? 'hidden sm:block' : ''">
        <div class="chat-sidebar" ref="scrollchat" @scroll="scrollChat">
          <div @click="$modal.show('iniciarConversa')" class="chat-mobile-new-button">
            <svg xmlns="http://www.w3.org/2000/svg" class="text-white h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
            </svg>
          </div>
          <section class="chat-filter-card">
            <div class="filter-heading">
              <div class="filter-icon">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M3 5h18M6 12h12M10 19h4" />
                </svg>
              </div>
              <div>
                <h2>Filtros</h2>
                <span>Refinar atendimento</span>
              </div>
            </div>
            <p class="filter-copy">Refine os atendimentos por operador, centro de custo, etiqueta e status.</p>
            <div class="mb-1" v-if="$store.state.user.admin || $store.state.user.visualizarFiltrosChat">
              <label for="operador" class="block text-sm font-medium text-gray-700"> Operador </label>

              <div class="relative group">
                <select v-model="operadorFind" name="operador" id="operador" class="chat-status-control cursor-pointer" :class="{ 'is-placeholder': !operadorFind }">
                  <option :value="null">Nenhum</option>
                  <option v-for="(p, idx) in operadores" :key="idx" :value="p._id">
                    {{ p.nome }}
                  </option>
                </select>

                <svg class="select-icon w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
            </div>

            <div class="mb-2" v-if="$store.state.user.admin || $store.state.user.visualizarFiltrosChat">
              <label for="centrocusto" class="block text-sm font-medium text-gray-700"> Centro de custo </label>

              <div class="relative group">
                <select v-model="centrocustoFind" name="centrocusto" id="centrocusto" class="chat-status-control cursor-pointer" :class="{ 'is-placeholder': !centrocustoFind }">
                  <option :value="null">Nenhum</option>
                  <option v-for="(c, idx) in centrocustos" :key="idx" :value="c._id">
                    {{ c.nome }}
                  </option>
                </select>

                <svg class="select-icon w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
            </div>

            <div class="mb-2">
              <label for="tag" class="block text-sm font-medium text-gray-700"> Etiqueta / Tabulação </label>

              <div class="relative group">
                <select v-model="tag" name="tag" id="tag" class="chat-status-control cursor-pointer" :class="{ 'is-placeholder': !tag }">
                  <option :value="null">Nenhum</option>
                  <option v-for="(t, idx) in tags" :key="idx" :value="t._id">
                    {{ t.nome }}
                  </option>
                </select>

                <svg class="select-icon w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
            </div>
            <div class="mb-2">
              <label for="filtrar" class="block text-sm font-medium text-gray-700">Status</label>
              <div class="relative group">
                <select v-model="filtrar" id="filtrar" name="filtrar" class="chat-status-control cursor-pointer" :class="{ 'is-placeholder': !filtrar }">
                  <option :value="null">Todos</option>
                  <option value="SemRespostas">Sem respostas</option>
                  <option value="Respondidas">Respondidas</option>
                </select>
                <svg class="select-icon w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
            </div>
            <div class="grid grid-cols-12 gap-4">
              <div class="col-span-12 md:col-span-6">
                <label for="data" class="block text-sm font-medium text-gray-700"> de: </label>
                <input type="date" @input="(event) => (data.de = event.target.value)" :value="data.de" class="chat-status-control" :class="{ 'is-placeholder': !data.de }" />
              </div>
              <div class="col-span-12 md:col-span-6">
                <label for="data" class="block text-sm font-medium text-gray-700"> até: </label>
                <input type="date" @input="(event) => (data.ate = event.target.value)" :value="data.ate" class="chat-status-control" :class="{ 'is-placeholder': !data.ate }" />
              </div>
            </div>
            <label for="search" class="filter-search-label">Buscar contato ou protocolo</label>
            <div class="grid grid-cols-12 gap-1">
              <div class="col-span-12">
                <input id="search" name="search" class="chat-status-control" v-model="search" placeholder="Ex.: Marcelo ou P9099D9A76B" type="text" @keyup.enter="start" />
              </div>
            </div>
            <div class="filter-actions">
              <button
                type="button"
                @click="start"
                class="inline-flex items-center justify-center px-6 py-2 rounded-full bg-blue-500 hover:bg-blue-600 text-white font-semibold text-sm shadow-xl shadow-blue-300/30 hover:shadow-blue-400/45 hover:-translate-y-0.5 transition-all duration-300 ease-in-out"
              >
                Aplicar filtros
              </button>

              <button
                type="button"
                @click="limparFiltros"
                class="inline-flex items-center justify-center px-6 py-2 rounded-full bg-white hover:bg-gray-100 border border-gray-200 text-gray-700 font-semibold text-sm shadow-xl shadow-gray-300/30 hover:shadow-gray-400/45 hover:-translate-y-0.5 transition-all duration-300 ease-in-out"
                style="background-color: #ffffff !important"
              >
                Limpar
              </button>
              <button
                v-if="$store.state.user.admin"
                type="button"
                class="btn-remove-neutral inline-flex justify-center items-center py-2 px-6 border border-gray-200 text-sm font-semibold rounded-full shadow-xl shadow-gray-300/30 hover:shadow-gray-400/45 hover:-translate-y-0.5 transition-all duration-300 ease-in-out focus:outline-none"
                @click="checaFiltrosParaFinalizarConversa()"
              >
                Finalizar conversas
              </button>
            </div>
          </section>
          <div class="chat-list-heading">
            <div>
              <h2>Chat</h2>
              <p>Selecione um atendimento para abrir a conversa.</p>
            </div>
            <span>{{ totalChats }}</span>
          </div>
          <div
            class="chat-list-item py-1 px-2 border-b rounded-xl mb-1 relative"
            v-for="item in listChats"
            :key="item._id"
            :class="[
              conversasSelecionadas.includes(item._id) || ($route.params.id && $route.params.id.toString() === item._id.toString()) ? 'chat-list-item--selected' : 'chat-list-item--default',
              {
                'chat-list-item--unread': item.naoLidas > 0,
                'chat-list-item--closed': !item.ativo,
                'chat-list-item--pending': item.ativo && item.ultimoAResponder === 'Operador',
                'chat-list-item--answered': item.ativo && item.ultimoAResponder === 'Cliente'
              }
            ]"
          >
            <router-link class="conversation-card-link" :class="!item.ativo ? 'opacity-50' : ''" @click.native="hiddenMenu = true" :to="`/chat/messages/${item._id}`">
              <div class="conversation-card-top">
                <span v-if="!item.contato.profilePic" class="chat-avatar chat-avatar--small">{{ getInitials(item.contato) }}</span>
                <img v-if="item.contato.profilePic" :src="item.contato.profilePic" alt="icon-avatar" class="chat-avatar chat-avatar--small" />

                <div class="conversation-card-main">
                  <div class="conversation-name-row">
                    <strong>{{ item.contato.nome ? item.contato.nome : item.contato.telefone }}</strong>
                    <span class="conversation-time">{{ item.dataMensagem | moment("DD/MM HH:mm") }}</span>
                  </div>
                  <div class="conversation-meta">
                    <span v-if="item.protocolo">Protocolo {{ item.protocolo }}</span>
                    <span v-if="item.centrocusto && item.centrocusto.nome">Centro de custo {{ item.centrocusto.nome }}</span>
                    <span v-if="item.operador && item.operador.nome">Operador {{ item.operador.nome }}</span>
                  </div>
                </div>
              </div>

              <div class="conversation-card-bottom">
                <p>{{ item.ultimaMensagem ? `${item.ultimaMensagem.substr(0, 72)}${item.ultimaMensagem.length > 72 ? "..." : ""}` : "Mídia" }}</p>
                <div class="conversation-card-footer">
                  <span
                    class="conversation-status"
                    :class="{
                      'conversation-status--closed': !item.ativo,
                      'conversation-status--pending': item.ativo && item.ultimoAResponder === 'Operador',
                      'conversation-status--answered': item.ativo && item.ultimoAResponder === 'Cliente'
                    }"
                  >
                    {{ !item.ativo ? "Encerrada" : item.ultimoAResponder === "Operador" ? "Sem resposta" : "Respondido" }}
                  </span>

                  <div class="conversation-card-actions">
                    <div class="conversation-card-tools">
                      <button
                        type="button"
                        @click.prevent.stop="openListarTags(item)"
                        :disabled="!chatTemEtiqueta(item)"
                        :class="{ 'conversation-card-tool--disabled': !chatTemEtiqueta(item) }"
                        aria-label="Ver etiquetas da conversa"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M7 7h.01M7 3h5.586a1 1 0 01.707.293l7.414 7.414a2 2 0 010 2.828l-7.172 7.172a2 2 0 01-2.828 0L3.293 13.293A1 1 0 013 12.586V7a4 4 0 014-4z" />
                        </svg>
                      </button>
                      <button type="button" @click.prevent.stop="openModalMover(item)" aria-label="Detalhes da conversa">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M12 6h.01M12 12h.01M12 18h.01" />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </aside>
      <main class="chat-main-shell" :class="!hiddenMenu ? 'hidden sm:block' : ''">
        <div class="chat-main-card">
          <div v-if="chat" class="chat-contact-header">
            <svg @click="hiddenMenu = false" xmlns="http://www.w3.org/2000/svg" class="h-7 w-7 absolute top-5 right-5 block sm:hidden z-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 15l-3-3m0 0l3-3m-3 3h8M3 12a9 9 0 1118 0 9 9 0 01-18 0z" />
            </svg>
            <div class="flex items-center space-x-4 px-1">
              <span v-if="!contact.profilePic || contact.profilePic === 'false'" class="chat-avatar chat-avatar--large">{{ getInitials(contact) }}</span>

              <img v-if="contact.profilePic && contact.profilePic !== 'false'" :src="contact.profilePic" alt="icon-avatar" class="chat-avatar chat-avatar--large" />

              <div class="chat-contact-summary">
                <div class="chat-contact-name-row">
                  <strong>{{ contact.nome ? uppercaseWords(contact.nome) : contact.telefone }}</strong>
                  <span v-if="obj_chat && obj_chat.ativo">Em andamento</span>
                  <span v-else class="is-closed">Encerrada</span>
                </div>
                <div class="chat-contact-meta-row">
                  <span>
                    <b>Protocolo:</b>
                    {{ contact.protocolo }}
                  </span>
                  <span v-if="contact.contrato">
                    <b>Contrato:</b>
                    {{ contact.contrato }}
                  </span>
                  <span v-if="$store.state.user.lzv2.centrocusto && centrocusto">
                    <b>Centro de custo:</b>
                    {{ centrocusto && centrocusto.nome ? centrocusto.nome : "" }}
                  </span>
                  <span v-if="operador">
                    <b>Operador:</b>
                    {{ operador && operador.nome ? operador.nome : "" }}
                  </span>
                  <span v-if="!!contact.quemEncerrou">
                    <b>Encerrada por:</b>
                    {{ contact.quemEncerrou }}
                  </span>
                </div>
              </div>
            </div>
            <div class="chat-contact-actions">
              <button type="button" class="chat-icon-button" @click="$refs['file-document'] && $refs['file-document'].click()" aria-label="Anexar arquivo">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13" />
                </svg>
              </button>
              <button v-if="obj_chat" type="button" class="chat-icon-button" @click="openModalMover(obj_chat)" aria-label="Detalhes da conversa">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M12 6h.01M12 12h.01M12 18h.01" />
                </svg>
              </button>
            </div>
          </div>
          <div id="messages" :class="chat ? 'bg-chat' : ''" class="h-screen flex flex-col p-3 overflow-y-auto scrollbar-thumb-blue scrollbar-thumb-rounded scrollbar-track-blue-lighter scrollbar-w-2 scrolling-touch">
            <div v-if="!chat" class="chat-empty-state flex min-h-full flex-col items-center justify-center px-8 py-10 text-center text-slate-500">
              <div class="chat-empty-icon mb-5 flex h-20 w-20 items-center justify-center rounded-3xl bg-blue-50 text-blue-600 shadow-lg shadow-blue-100/70">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M8 10h.01M12 10h.01M16 10h.01M21 12c0 4.418-4.03 8-9 8a9.77 9.77 0 01-4-.82L3 20l1.32-3.52A7.48 7.48 0 013 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                </svg>
              </div>

              <h2 class="m-0 text-2xl font-semibold text-slate-950">Nenhuma conversa aberta</h2>
              <p class="mt-3 max-w-sm text-sm leading-6 text-slate-500">Selecione um card de conversa na lateral para visualizar o atendimento aqui.</p>
            </div>
            <div class="chat-message" v-for="(msg, i) in list" :key="i">
              <div class="flex items-end" :class="{ 'justify-end': msg.me }">
                <div
                  class="flex flex-col space-y-2 text-sm_3 max-w-xs mx-2"
                  :class="{
                    'order-2 items-start': !msg.me,
                    'order-1 items-end': msg.me
                  }"
                >
                  <div class="max-w-xs">
                    <div
                      :class="{
                        'rounded-br-none': msg.me && i === msg.length - 1,
                        'rounded-bl-none': !msg.me && i === msg.length - 1,
                        'bg-chat-me text-gray-800': msg.me,
                        'bg-white text-gray-800': !msg.me
                      }"
                      class="px-2 py-3 my-2 sm:mt-0 rounded-lg inline-block break-line"
                    >
                      <!-- RESPOSTAS DE MENSAGEM MENCIONADA -->
                      <p class="bg-blue-500 border-2 border-blue-600 text-white p-2 mb-2 rounded-lg" v-if="msg.quotedMsg">
                        <span v-if="msg.quotedType === 'chat'">{{ msg.quotedMsg }}</span>
                        <span v-if="msg.quotedType !== 'chat'">
                          <audio v-if="isQuotedAudio(msg)" controls>
                            <source :src="getQuotedMediaUrl(msg)" :type="msg.quotedMimetype || 'audio/ogg'" />
                            Your browser does not support the audio element.
                          </audio>
                          <img v-else-if="getQuotedMediaUrl(msg)" style="height: 50px" alt="img" className="rounded mb-2" :src="getQuotedMediaUrl(msg)" />
                        </span>
                        <br />
                      </p>

                      <p v-if="(!msg.type || msg.type === 'chat') && !msg.mensagem?.match(/VCARD/im)" v-html="getHtmlFrom(msg.mensagem)"></p>
                      <p v-if="(!msg.type || msg.type === 'vcard') && msg.mensagem?.match(/VCARD/im)" v-html="getHtmlFrom(getVcard(msg.mensagem))"></p>

                      <!-- IMAGEM -->
                      <a v-if="msg.type === 'image' && getUploadUrl(msg)" @click="openModalImg(getUploadUrl(msg))">
                        <img style="height: 250px" alt="img" className="rounded mb-2" :src="getUploadUrl(msg)" />
                      </a>
                      <p v-else-if="msg.type === 'image'" class="text-xs text-red-600 font-semibold">Imagem recebida, mas o arquivo ainda nao esta disponivel.</p>

                      <img style="height: 250px" v-if="msg.type === 'image_file'" alt="img" className="rounded mb-2" :src="msg.base64" />

                      <p
                        v-if="
                          ($store.state.user.operador && $store.state.user.usuario.toString() === '67af9a206483ece039972e86' && msg.type === 'sticker') ||
                          (!$store.state.user.operador && $store.state.user._id.toString() === '67af9a206483ece039972e86' && msg.type === 'sticker')
                        "
                        class="font-bold"
                      >
                        Figurinha bloqueada pelo sistema
                      </p>
                      <a v-else-if="msg.type === 'sticker'" target="blank" :href="getUploadUrl(msg)">
                        <img style="height: 250px" alt="img" className="rounded mb-2" :src="getUploadUrl(msg)" />
                      </a>

                      <a v-if="msg.type === 'document' && msg.mensagem" target="blank" :href="getUploadUrl(msg)">
                        <img v-if="msg.message" style="height: 250px" alt="img" className="rounded mb-2" :src="`data:image/jpeg;base64,${msg.message}`" />
                        <b v-else>Documento: {{ msg.filename ? msg.filename : "" }}</b>
                      </a>

                      <a v-if="msg.type === 'location' && msg.message" target="blank" :href="`https://www.google.com/maps?q=${msg.lat},${msg.lng}&z=17&hl=pt-BR`">
                        <img v-if="msg.mensagem" style="height: 100px" alt="img" className="rounded mb-2" :src="`data:image/jpeg;base64,${msg.mensagem}`" />
                      </a>

                      <a v-if="msg.type === 'document' && !msg.mensagem" target="blank" :href="getUploadUrl(msg, { original: msg.filename })">
                        <b>Documento:</b>
                        <br />{{ msg.originalname ? msg.originalname : msg.filename }}
                      </a>

                      <a v-if="msg.type === 'document_file' && !msg.message" target="blank" :href="msg.base64">
                        <b>Documento:</b>
                        <br />{{ msg.originalname ? msg.originalname : "" }}
                      </a>

                      <audio controls v-if="msg.type === 'ptt' || msg.type === 'audio'">
                        <source :src="getUploadUrl(msg)" :type="msg.mimetype" />
                        Your browser does not support the audio element.
                      </audio>

                      <video controls v-if="msg.type === 'video'">
                        <source :src="getUploadUrl(msg)" :type="msg.mimetype" />
                        Your browser does not support the video element.
                      </video>
                      <br />
                      <span class="text-xs float-right">
                        {{ msg.t | moment("DD/MM/YYYY HH:mm") }}
                        <span v-if="msg.status === 0 && msg.me" class="font-bold">SEM Whatsapp (Número inválido)</span>
                        <span v-if="msg.status === 55" class="font-bold">Limite de envios atingido</span>
                        <span v-if="msg.status === 9" class="font-bold">Não enviado (Erro ao enviar)</span>
                        <svg
                          v-if="msg.status > 2 && msg.status !== 0 && msg.status !== 55 && msg.status !== 9"
                          xmlns="http://www.w3.org/2000/svg"
                          class="inline text-blue-300 h-4 mb-1 ml-1"
                          :fill="msg.status === 3 ? '#272525' : '#0088ff'"
                          viewBox="0 0 256 256"
                        >
                          <rect width="256" height="256" fill="none"></rect>
                          <polyline points="148 84 60 172 16 128" fill="none" :stroke="msg.status === 3 ? '#272525' : '#0088ff'" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></polyline>
                          <polyline points="240 84 152 172 128.6 148.6" fill="none" :stroke="msg.status === 3 ? '#272525' : '#0088ff'" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></polyline>
                        </svg>
                        <svg v-if="msg.status && msg.status < 3" xmlns="http://www.w3.org/2000/svg" class="inline text-blue-300 h-4 mb-1 ml-1" fill="#272525" viewBox="0 0 256 256">
                          <rect width="256" height="256" fill="none"></rect>
                          <polyline points="216 72 104 184 48 128" fill="none" stroke="#272525" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></polyline>
                        </svg>
                        <svg
                          v-if="(msg.status === 0 && msg.me) || msg.status === 9 || msg.status === 55"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          class="inline text-red-600 font-bold h-4 mb-1 ml-1"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z"
                            clip-rule="evenodd"
                          />
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="chat" class="border-t-2 border-gray-200 px-1 py-1 md:px-2 md:py-2 relative">
            <div v-if="menuEmoji" class="absolute bottom-20 left-5 z-10">
              <VEmojiPicker @select="selectEmoji" />
            </div>
            <div>
              <div v-if="obj_chat && obj_chat.ativo" class="chat-composer">
                <span class="chat-composer-left">
                  <label
                    v-if="!($store.state.user && $store.state.user.lzv2 && $store.state.user.lzv2.bloquearAudio)"
                    @click="toggleRecording"
                    for="file-audio"
                    class="chat-composer-action inline-flex items-center justify-center rounded-full cursor-pointer ml-1 h-9 w-9 transition duration-300 ease-in-out text-gray-500 hover:bg-gray-100 hover:shadow-gray-200/50 focus:outline-none"
                    :class="{ 'border-2 border-red-400 animate-pulse bg-red-100': isRecording }"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-5 w-5 text-gray-600">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"></path>
                    </svg>
                  </label>

                  <label
                    v-if="!($store.state.user && $store.state.user.lzv2 && $store.state.user.lzv2.bloquearEmojis)"
                    @click="menuEmoji = !menuEmoji"
                    for="file-emoji"
                    class="chat-composer-action inline-flex items-center justify-center rounded-full cursor-pointer h-9 w-9 transition duration-300 ease-in-out text-gray-500 hover:bg-gray-100 hover:shadow-gray-200/50 focus:outline-none"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </label>
                </span>
                <textarea
                  v-on:input="auto_grow()"
                  v-on:keydown.enter.exact="send"
                  rows="1"
                  v-model="message"
                  type="text"
                  :placeholder="$t('txt-writeSomething')"
                  id="sendtextarea"
                  class="chat-message-input w-full focus:outline-none focus:placeholder-gray-400 text-gray-600 placeholder-gray-600 bg-gray-200 rounded-full overflow-hidden resize-none min-h-41 max-h-97 px-4 py-3"
                />
                <div class="chat-composer-right">
                  <label
                    type="button"
                    for="file-document"
                    class="chat-composer-action inline-flex items-center justify-center rounded-full cursor-pointer h-10 w-10 transition duration-300 ease-in-out text-gray-500 hover:bg-gray-100 hover:shadow-gray-200/50 focus:outline-none"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-6 w-6 text-gray-600">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"></path>
                    </svg>
                    <input type="file" class="hidden" id="file-document" ref="file-document" v-on:change="handleFileUpload('file-document')" />
                  </label>
                  <label
                    type="button"
                    for="file-image"
                    class="chat-composer-action inline-flex items-center justify-center rounded-full cursor-pointer h-10 w-10 transition duration-300 ease-in-out text-gray-500 hover:bg-gray-100 hover:shadow-gray-200/50 focus:outline-none"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-6 w-6 text-gray-600">
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
                      ></path>
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"></path>
                    </svg>
                    <input type="file" class="hidden" id="file-image" ref="file-image" v-on:change="handleFileUpload('file-image')" accept="image/*,video/*" />
                  </label>
                  <button
                    @click="send"
                    type="button"
                    class="chat-composer-send inline-flex items-center justify-center rounded-full h-12 w-12 transition duration-300 ease-in-out text-white bg-blue-500 hover:bg-blue-600 hover:shadow-blue-300/40 hover:-translate-y-0.5"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="h-6 w-6 transform rotate-90">
                      <path d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z"></path>
                    </svg>
                  </button>
                </div>
              </div>
              <div v-else class="relative flex">
                <span class="text-xl text-blue-700 font-semibold">Conversa desativada</span>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
    <modal name="iniciarConversa" height="auto" width="672" :adaptive="true" classes="chat-rounded-modal rounded-3xl overflow-hidden" :styles="{ borderRadius: '24px', overflow: 'hidden', background: 'transparent' }">
      <div class="chat-modal overflow-hidden rounded-3xl bg-white">
        <form>
          <div class="chat-modal-header flex items-start justify-between gap-5 border-b border-gray-100 px-6 py-5">
            <div>
              <h2>Nova conversa</h2>
              <p>Preencha os dados do contato e configure a conversa.</p>
            </div>
            <button
              type="button"
              class="chat-modal-close inline-flex h-10 w-10 items-center justify-center rounded-2xl border border-slate-200 bg-white text-slate-500 shadow-sm transition hover:bg-slate-50"
              @click="$modal.hide('iniciarConversa')"
              aria-label="Fechar"
            >
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <div class="grid grid-cols-12 gap-2 gap-y-2">
            <div class="col-span-12">
              <label for="nome" class="block text-sm font-medium text-gray-700">Nome do cliente</label>
              <input v-model="formConversa.nome" type="text" name="nome" placeholder="Ex.: Marcelo Braga Borges" id="nome" class="chat-status-control" />
            </div>
            <div class="col-span-12 md:col-span-6">
              <label for="telefone" class="block text-sm font-medium text-gray-700">Telefone do cliente</label>
              <input v-model="formConversa.telefone" type="number" name="telefone" placeholder="(11) 99999-9999" id="telefone" class="chat-status-control" />
            </div>
            <div v-if="$store.state.user.lzv2.contato_contrato" class="col-span-12 md:col-span-6">
              <label for="contrato" class="block text-sm font-medium text-gray-700">Número do contrato</label>
              <input v-model="formConversa.contrato" type="text" name="contrato" placeholder="Ex.: 123456" id="contrato" class="chat-status-control" />
            </div>
            <div v-if="$store.state.user.lzv2.contato_contrato" class="col-span-12 md:col-span-6">
              <label for="cpf" class="block text-sm font-medium text-gray-700">CPF / CNPJ do cliente</label>
              <input v-model="formConversa.cpf" type="text" name="cpf" placeholder="000.000.000-00" id="cpf" class="chat-status-control" />
            </div>
            <div v-if="!$store.state.user.operador || $store.state.user.admin" class="col-span-12 md:col-span-6">
              <label for="operador" class="block text-sm font-medium text-gray-700">Operador</label>
              <div class="relative group">
                <select v-model="formConversa.operador" id="operador" name="operador" class="chat-status-control cursor-pointer">
                  <option :value="null">Nenhum</option>
                  <option v-for="(p, idx) in operadores" :key="idx" :value="p._id">
                    {{ p.nome }}
                  </option>
                </select>
                <svg class="select-icon w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
            </div>
            <div class="col-span-12 md:col-span-6">
              <label class="block text-sm font-medium text-gray-700">Etiquetas / Tabulações</label>
              <div class="relative group">
                <select v-model="tag" name="tag" id="tag" class="chat-status-control cursor-pointer">
                  <option :value="null">Nenhum</option>
                  <option v-for="(t, idx) in tags" :key="idx" :value="t._id">
                    {{ t.nome }}
                  </option>
                </select>

                <svg class="select-icon w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
            </div>
            <div class="col-span-12">
              <div class="flex items-center justify-between mb-2">
                <label for="mensagem" class="block text-sm font-medium text-gray-700">Mensagem</label>
                <label class="predefined-message-toggle">
                  <input type="checkbox" v-model="usarMensagemCriada" />
                  <span>Utilizar pré definidas</span>
                </label>
              </div>

              <div v-if="usarMensagemCriada" class="relative group mb-3">
                <select id="premsg" v-model="newPreMensagem" class="chat-status-control cursor-pointer">
                  <option :value="null">Selecione a mensagem</option>
                  <option v-for="(p, idx) in preMensagens" :key="idx" :value="p">
                    {{ p.titulo }}
                  </option>
                </select>
                <svg class="select-icon w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>

              <textarea v-model="formConversa.mensagem" name="mensagem" placeholder="Olá tudo bem?" id="mensagem" rows="3" class="chat-status-control"></textarea>
            </div>
            <div class="col-span-12 chat-modal-actions flex justify-end gap-3 border-t border-gray-100 pt-5 mt-2">
              <button
                type="button"
                @click="$modal.hide('iniciarConversa')"
                class="inline-flex items-center justify-center px-6 py-3 rounded-2xl bg-white hover:bg-gray-100 border border-gray-200 text-white font-semibold text-sm shadow-lg hover:shadow-gray-300/40 hover:-translate-y-0.5 transition-all duration-300 ease-in-out"
              >
                Cancelar
              </button>
              <button
                @click="novaConversa"
                type="button"
                class="inline-flex items-center justify-center px-6 py-3 rounded-2xl bg-blue-500 hover:bg-blue-600 text-white font-semibold text-sm shadow-lg hover:shadow-blue-300/40 hover:-translate-y-0.5 transition-all duration-300 ease-in-out"
              >
                Abrir conversa
              </button>
            </div>
          </div>
        </form>
      </div>
    </modal>
    <modal name="moverConversa" height="auto" width="672" :adaptive="true" classes="chat-rounded-modal rounded-3xl overflow-hidden" :styles="{ borderRadius: '24px', overflow: 'hidden', background: 'transparent' }">
      <div class="chat-modal overflow-hidden rounded-3xl bg-white">
        <div class="chat-modal-header flex items-start justify-between gap-5 border-b border-gray-100 px-6 py-5">
          <div>
            <h2>Detalhes da conversa</h2>
            <p>Gerencie as informações do atendimento.</p>
          </div>
          <button
            type="button"
            class="chat-modal-close inline-flex h-10 w-10 items-center justify-center rounded-2xl border border-slate-200 bg-white text-slate-500 shadow-sm transition hover:bg-slate-50"
            @click="$modal.hide('moverConversa')"
            aria-label="Fechar"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div class="chat-modal-tabs overflow-x-auto border-b border-gray-100 bg-slate-50 px-6 py-3">
          <div class="flex space-x-4">
            <label
              @click="config = 'info'"
              class="inline-flex min-h-9 cursor-pointer items-center whitespace-nowrap rounded-xl px-3 text-xs font-semibold text-slate-600 transition hover:bg-white sm:text-sm"
              :class="config === 'info' ? 'bg-blue-50 text-blue-700 shadow-sm' : ''"
            >
              Informações
            </label>
            <label
              @click="config = 'tags'"
              class="inline-flex min-h-9 cursor-pointer items-center whitespace-nowrap rounded-xl px-3 text-xs font-semibold text-slate-600 transition hover:bg-white sm:text-sm"
              :class="config === 'tags' ? 'bg-blue-50 text-blue-700 shadow-sm' : ''"
            >
              Tabulações / Etiquetas
            </label>
            <label
              @click="config = 'avaliacao'"
              class="inline-flex min-h-9 cursor-pointer items-center whitespace-nowrap rounded-xl px-3 text-xs font-semibold text-slate-600 transition hover:bg-white sm:text-sm"
              :class="config === 'avaliacao' ? 'bg-blue-50 text-blue-700 shadow-sm' : ''"
            >
              Avaliação
            </label>
            <label
              @click="config = 'mover'"
              class="inline-flex min-h-9 cursor-pointer items-center whitespace-nowrap rounded-xl px-3 text-xs font-semibold text-slate-600 transition hover:bg-white sm:text-sm"
              :class="config === 'mover' ? 'bg-blue-50 text-blue-700 shadow-sm' : ''"
            >
              Mover Conversa
            </label>
          </div>
        </div>
        <div v-show="config === 'avaliacao'">
          <button
            @click="enviarAvaliacao"
            type="button"
            class="inline-flex items-center justify-center px-6 py-3 rounded-2xl bg-blue-500 hover:bg-blue-600 text-white font-semibold text-sm shadow-lg hover:shadow-blue-300/40 hover:-translate-y-0.5 transition-all duration-300 ease-in-out"
          >
            Enviar pesquisa de Avaliação
          </button>
        </div>
        <div v-if="config === 'tags'" class="h-36">
          <div class="relative group mt-2">
            <select v-model="tagModal" name="tag" id="tag" class="chat-status-control cursor-pointer">
              <option :value="null">Nenhum</option>
              <option v-for="(t, idx) in tags" :key="idx" :value="t._id">
                {{ t.nome }}
              </option>
            </select>

            <svg class="select-icon w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </div>
          <div class="grid grid-cols-12 mt-4">
            <div class="col-span-12">
              <button
                @click="saveChat"
                type="button"
                class="inline-flex items-center justify-center px-6 py-3 rounded-2xl text-white font-semibold text-sm shadow-lg hover:-translate-y-0.5 transition-all duration-300 ease-in-out"
                :class="finalizarConversa ? 'bg-red-600 hover:bg-red-700 hover:shadow-red-300/40' : 'bg-blue-500 hover:bg-blue-600 hover:shadow-blue-300/40'"
              >
                {{ finalizarConversa ? "Salvar Etiquetas e Finalizar Conversa" : "Salvar Etiquetas" }}
              </button>
            </div>
          </div>
        </div>
        <div v-show="config === 'info'">
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12 md:col-span-6">
              <label for="nome" class="block text-sm font-medium">Nome</label>
              <input v-model="form.contato.nome" type="text" name="nome" id="nome" class="chat-status-control" />
            </div>
            <div class="col-span-12 md:col-span-6 opacity-50">
              <label for="telefone" class="block text-sm font-medium">Telefone</label>
              <input v-model="form.contato.telefone" disabled type="number" name="telefone" id="telefone" class="chat-status-control" />
            </div>
            <div class="col-span-12 md:col-span-6">
              <label for="contrato" class="block text-sm font-medium">CPF / CNPJ</label>
              <input v-model="form.contato.cpf" type="text" name="contrato" id="contrato" class="chat-status-control" />
            </div>
            <div class="col-span-12 md:col-span-6">
              <label for="contrato" class="block text-sm font-medium">Contrato</label>
              <input v-model="form.contato.contrato" type="text" name="contrato" id="contrato" class="chat-status-control" />
            </div>
            <div class="col-span-12 justify-self-end">
              <button
                @click="saveChat"
                type="button"
                class="inline-flex items-center justify-center px-6 py-3 rounded-2xl bg-blue-500 hover:bg-blue-600 text-white font-semibold text-sm shadow-lg hover:shadow-blue-300/40 hover:-translate-y-0.5 transition-all duration-300 ease-in-out"
              >
                Salvar Conversa
              </button>
            </div>
          </div>
        </div>
        <div v-show="config === 'mover'">
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <label for="operador" class="block text-sm font-medium text-gray-700">Operador</label>
              <div class="relative group">
                <select v-model="form.operador" id="operador" name="operador" class="chat-status-control cursor-pointer">
                  <option :value="null">Nenhum</option>
                  <option v-for="(p, idx) in operadores" :key="idx" :value="p._id">
                    {{ p.nome }}
                  </option>
                </select>
                <svg class="select-icon w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
            </div>
            <div class="col-span-6">
              <button
                @click="arquivarConversa(conversasSelecionadas.length > 0)"
                type="button"
                class="btn-remove-neutral inline-flex items-center justify-center w-full px-6 py-3 rounded-2xl border border-gray-200 text-gray-700 font-semibold text-sm shadow-lg shadow-gray-300/30 hover:shadow-gray-400/45 hover:-translate-y-0.5 transition-all duration-300 ease-in-out"
              >
                Finalizar Conversa
              </button>
            </div>
            <div class="col-span-6 justify-self-end">
              <button
                @click="moverChat"
                type="button"
                class="inline-flex items-center justify-center px-6 py-3 rounded-2xl bg-blue-500 hover:bg-blue-600 text-white font-semibold text-sm shadow-lg hover:shadow-blue-300/40 hover:-translate-y-0.5 transition-all duration-300 ease-in-out w-full"
              >
                Mover Conversa
              </button>
            </div>
          </div>
          <h3 class="font-bold mb-2 mt-2">Histórico</h3>
          <div class="overflow-auto">
            <table class="min-w-full divide-y divide-gray-200">
              <thead class="bg-gray-50">
                <tr>
                  <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Movimentação</th>
                  <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Data</th>
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
                <tr v-for="(item, idx) in form.historico" :key="idx">
                  <td class="px-6 py-4 whitespace-nowrap">
                    <div class="flex">
                      <div class="text-sm text-gray-500">
                        {{ item.acao || (item.operador && item.operador.nome ? item.operador.nome : "") }}
                      </div>
                    </div>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap">
                    <div class="flex">
                      <div v-if="item.data" class="text-sm text-gray-500">
                        {{ item.data | moment("DD/MM/YYYY HH:mm") }}
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <a
            v-if="this.form && this.form.chat && this.form.chat._id"
            :href="`${api}/v1/chatV2/downloadConversa/${this.form.chat._id}?token=${$store.state.token}`"
            role="button"
            type="button"
            class="flex h-11 w-full items-center justify-center gap-2 rounded-xl border border-gray-200 bg-white px-4 font-medium text-gray-700 shadow-sm transition hover:bg-gray-50 mt-4"
          >
            <svg class="h-5 w-5 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 3v12m0 0l-3.5-3.5M12 15l3.5-3.5M4 21h16" />
            </svg>
            Download Conversa
          </a>
        </div>
      </div>
    </modal>
    <modal name="imgModal" height="auto">
      <div class="w-full">
        <img :src="imgmodal" alt="img_chat" class="w-full" />
      </div>
    </modal>
    <modal name="listarTags" height="auto" width="640" :adaptive="true" classes="chat-rounded-modal rounded-3xl overflow-hidden" :styles="{ borderRadius: '24px', overflow: 'hidden', background: 'transparent' }">
      <div class="tags-modal">
        <div class="tags-modal-header">
          <div>
            <h2>Tabulacoes / Etiquetas</h2>
            <p>{{ tagsList.length }} {{ tagsList.length === 1 ? "etiqueta vinculada" : "etiquetas vinculadas" }}</p>
          </div>
          <button type="button" class="tags-modal-close" @click="$modal.hide('listarTags')" aria-label="Fechar etiquetas">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div class="tags-modal-list" v-if="tagsList.length > 0">
          <span v-for="(item, idx) in tagsList" :key="idx" class="tags-modal-chip" :style="getTagChipStyle(item)">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M7 7h.01M7 3h5.586a1 1 0 01.707.293l7.414 7.414a2 2 0 010 2.828l-7.172 7.172a2 2 0 01-2.828 0L3.293 13.293A1 1 0 013 12.586V7a4 4 0 014-4z" />
            </svg>
            {{ item.nome }}
          </span>
        </div>

        <div v-else class="tags-modal-empty">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-9 w-9" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8">
            <path stroke-linecap="round" stroke-linejoin="round" d="M7 7h.01M7 3h5.586a1 1 0 01.707.293l7.414 7.414a2 2 0 010 2.828l-7.172 7.172a2 2 0 01-2.828 0L3.293 13.293A1 1 0 013 12.586V7a4 4 0 014-4z" />
          </svg>
          <p>Nenhuma etiqueta vinculada a esta conversa.</p>
        </div>
      </div>
    </modal>

    <modal name="confirmacaoSenha" height="auto">
      <div class="px-2 py-3">
        <h1 class="text-xl font-bold">Digite usuário e senha para confirmar essa operação:</h1>
        <form @submit.prevent="confereSenha()">
          <input :required="true" class="chat-status-control my-2" v-model="confirmacao.usuario" placeholder="Digite seu email (ex: operador@lz.com)" type="text" />
          <input :required="true" class="chat-status-control my-2" v-model="confirmacao.senha" placeholder="Digite sua senha" type="password" />
          <button
            class="my-1 inline-flex items-center justify-center px-6 py-3 rounded-2xl bg-blue-600 hover:bg-blue-700 text-white font-semibold text-sm shadow-lg hover:shadow-blue-300/40 hover:-translate-y-0.5 transition-all duration-300 ease-in-out"
          >
            Confirmar
          </button>
        </form>
      </div>
    </modal>
  </div>
</template>
<script>
import vCard from "vcard-parser";
import moment from "moment";
import { VEmojiPicker } from "v-emoji-picker";
import { formatarMensagem } from "@/utils/formatarMensagem";

const TAG_REQUIRED_CLOSE_USER_ID = "656a0ba7e71e12d7b00b256e";

export default {
  name: "Messages",
  components: {
    VEmojiPicker
  },
  data() {
    return {
      moment: moment,
      imgmodal: "",
      finalizarConversa: false,
      hiddenMenu: false,
      menuEmoji: false,
      dedupWindowMs: 90 * 1000,
      route: "chatV2",
      list: [],
      conversasSelecionadas: [],
      tags: [],
      confirmacao: {
        senha: "",
        usuario: "",
        filtro: null
      },
      filtrar: null,
      operadores: [],
      data: {
        de: null,
        ate: null
      },
      centrocustos: [],
      tagsList: [],
      bloqueiaScroll: false,
      formConversa: {
        nome: "",
        telefone: "",
        mensagem: "",
        contrato: "",
        tags: [],
        operador: null
      },
      config: "info",
      form: {
        chat: null,
        operador: null,
        contato: {
          nome: "",
          telefone: "",
          contrato: "",
          cpf: ""
        }
      },
      message: "",
      total: 0,
      contact: false,
      listChats: [],
      chat: false,
      obj_chat: null,
      operador: null,
      operadorFind: null,
      centrocustoFind: null,
      centrocusto: null,
      search: "",
      tag: null,
      tagModal: null,
      totalChats: 0,
      totalQuePodeSerFinalizado: 0,
      semRespostas: 0,
      respondidas: 0,
      limit: 30,
      isRecording: false,
      mediaRecorder: null,
      audioChunks: [],
      audioUrl: null,
      audioBlob: null,
      mediaStream: null,
      usarMensagemCriada: false,
      preMensagens: [],
      newPreMensagem: null
    };
  },

  watch: {
    newPreMensagem(value) {
      if (!value) {
        this.formConversa.mensagem = "";
        return;
      }

      this.formConversa.mensagem = value.mensagem;
    }
  },

  methods: {
    getTagId(tag) {
      if (!tag) return null;
      if (typeof tag === "string") return tag;
      return tag._id || tag.id || null;
    },
    getTagById(tagId) {
      if (!tagId) return null;
      return (this.tags || []).find((item) => this.getTagId(item) === tagId) || null;
    },
    isValidHexColor(value) {
      return typeof value === "string" && /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(value);
    },
    normalizeHexColor(value) {
      if (!this.isValidHexColor(value)) return null;
      if (value.length === 7) return value;
      return `#${value[1]}${value[1]}${value[2]}${value[2]}${value[3]}${value[3]}`;
    },
    hexToRgb(hex) {
      const normalized = this.normalizeHexColor(hex);
      if (!normalized) return null;

      const bigint = parseInt(normalized.slice(1), 16);
      return {
        r: (bigint >> 16) & 255,
        g: (bigint >> 8) & 255,
        b: bigint & 255
      };
    },
    getTagChipStyle(tag) {
      if (!tag || !tag.editarCorDaEtiqueta || !tag.corDaEtiqueta) return {};

      const normalizedColor = this.normalizeHexColor(tag.corDaEtiqueta);
      const rgb = this.hexToRgb(normalizedColor);
      if (!normalizedColor || !rgb) return {};

      const luminance = (0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b) / 255;
      const textColor = luminance > 0.72 ? "#0f172a" : normalizedColor;

      return {
        color: textColor,
        borderColor: normalizedColor,
        backgroundColor: `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.16)`,
        boxShadow: `0 7px 16px rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.18)`
      };
    },
    getPrimaryTagName(tags) {
      if (!Array.isArray(tags) || tags.length === 0) return "";

      const firstTag = tags[0];
      if (!firstTag) return "";
      if (typeof firstTag === "object") return firstTag.nome || "";

      const tagById = this.getTagById(firstTag);
      return tagById && tagById.nome ? tagById.nome : "";
    },
    getNormalizedSearch() {
      return this.search.replace("(", "").replace(")", "");
    },
    buildChatListPayload(extra = {}) {
      const busca = this.getNormalizedSearch();

      return {
        limit: this.limit,
        tipo: this.getTipoBusca(busca),
        busca,
        tag: this.tag,
        operador: this.operadorFind,
        filtrar: this.filtrar,
        centrocusto: this.centrocustoFind,
        de: this.data.de,
        ate: this.data.ate,
        ...extra
      };
    },
    isChatPendente(chat) {
      return !!(chat && chat.ativo && chat.ultimoAResponder === "Operador");
    },
    isChatRespondido(chat) {
      return !!(chat && chat.ativo && chat.ultimoAResponder === "Cliente");
    },
    setChatListStats(stats) {
      const total = Number(stats.total || 0);
      const semRespostas = Number(stats.semRespostas || 0);
      const respondidas = Number(stats.respondidas);

      this.totalChats = total;
      this.semRespostas = semRespostas;
      this.respondidas = Number.isNaN(respondidas) ? Math.max(0, total - semRespostas) : respondidas;
    },
    syncChatStatusCounters(chatAnterior, chatAtual) {
      const eraPendente = this.isChatPendente(chatAnterior);
      const ficouPendente = this.isChatPendente(chatAtual);
      const eraRespondido = this.isChatRespondido(chatAnterior);
      const ficouRespondido = this.isChatRespondido(chatAtual);

      if (eraPendente !== ficouPendente) {
        this.semRespostas += ficouPendente ? 1 : -1;
      }

      if (eraRespondido !== ficouRespondido) {
        this.respondidas += ficouRespondido ? 1 : -1;
      }

      this.semRespostas = Math.max(0, this.semRespostas);
      this.respondidas = Math.max(0, this.respondidas);
    },
    getTipoBusca(busca) {
      const valor = String(busca || "").trim();
      const limpo = valor.replace(/[()\s.-]/g, "");

      if (!valor) return "nome";
      if (/^P[A-Z0-9]+$/i.test(limpo)) return "protocolo";
      if (/^\d+$/.test(limpo)) return "telefone";

      return "nome";
    },
    getInitials(contact = {}) {
      const value = contact.nome || contact.name || contact.telefone || contact.phone || "";
      const parts = String(value).trim().split(/\s+/).filter(Boolean);

      if (parts.length === 0) return "--";
      if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();

      return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(0)}`.toUpperCase();
    },
    buildUploadUrl({ mimetype, filename, folder, original } = {}) {
      if (!filename) return "";

      const params = new URLSearchParams();
      if (mimetype) params.set("mimetype", mimetype);
      params.set("filename", filename);
      params.set("folder", folder || "arquivosWhats");
      if (original) params.set("original", original);

      return `${this.api}/upload?${params.toString()}`;
    },
    getUploadUrl(file = {}, options = {}) {
      return this.buildUploadUrl({
        mimetype: file.mimetype,
        filename: file.filename,
        folder: file.folder,
        original: options.original || file.originalname
      });
    },
    isDirectMediaUrl(value) {
      return typeof value === "string" && /^(https?:|data:)/i.test(value);
    },
    isBase64Like(value) {
      return typeof value === "string" && /^[A-Za-z0-9+/]+={0,2}$/.test(value);
    },
    getQuotedMediaUrl(msg = {}) {
      if (!msg.quotedMsg || msg.quotedType === "chat") return "";
      if (this.isDirectMediaUrl(msg.quotedMsg)) return msg.quotedMsg;

      if (msg.quotedFilename) {
        return this.buildUploadUrl({
          mimetype: msg.quotedMimetype || msg.mimetype || "image/jpeg",
          filename: msg.quotedFilename,
          folder: msg.folder
        });
      }

      if (this.isBase64Like(msg.quotedMsg)) {
        const mimetype = msg.quotedMimetype || "image/jpeg";
        return `data:${mimetype};base64,${msg.quotedMsg}`;
      }

      return this.buildUploadUrl({
        mimetype: msg.quotedMimetype || msg.mimetype || "image/jpeg",
        filename: msg.quotedMsg,
        folder: msg.folder
      });
    },
    isQuotedAudio(msg = {}) {
      const url = this.getQuotedMediaUrl(msg);
      return (msg.quotedMimetype && msg.quotedMimetype.indexOf("audio/") === 0) || (typeof url === "string" && url.indexOf("data:audio") === 0);
    },
    getMsgTimestamp(msg) {
      if (!msg) return null;
      const t = msg.t;
      if (typeof t === "number" && t > 0) {
        return t < 2e12 ? t * 1000 : t;
      }
      if (msg.data) {
        const dt = new Date(msg.data).getTime();
        return isNaN(dt) ? null : dt;
      }
      return null;
    },
    getMsgBaseKey(msg) {
      const type = (msg && msg.type) || "chat";
      switch (type) {
        case "chat":
        case undefined:
          return `chat|${((msg && (msg.mensagem || "")) || "").trim()}`;
        case "image":
        case "video":
        case "document":
        case "sticker":
        case "audio":
        case "ptt":
        case "location":
          if (msg.filename) return `${type}|file:${msg.filename}`;
          if (msg.originalname || msg.mimetype) return `${type}|orig:${msg.originalname || ""}|${msg.mimetype || ""}`;
          if (msg.link) return `${type}|link:${msg.link}`;
          if (msg.lat || msg.lng) return `${type}|geo:${msg.lat || ""},${msg.lng || ""}`;
          break;
        case "image_file":
        case "document_file":
          if (msg.base64) return `${type}|b64:${msg.base64.slice(0, 64)}`;
          break;
        default:
          break;
      }
      return `${type}|${(msg && (msg.mensagem || "")) || ""}|${msg && msg.mimetype ? msg.mimetype : ""}`;
    },
    getMsgDedupKey(msg) {
      const ts = this.getMsgTimestamp(msg);
      if (ts === null) return null;
      const bucket = Math.floor(ts / this.dedupWindowMs);
      const base = this.getMsgBaseKey(msg);
      return `${base}|${bucket}`;
    },
    isDuplicateMessage(list, incoming) {
      if (!incoming) return false;
      const key = this.getMsgDedupKey(incoming);
      if (!key) return false;
      for (let i = Math.max(0, list.length - 200); i < list.length; i++) {
        const k = this.getMsgDedupKey(list[i]);
        if (k && k === key) return true;
      }
      return false;
    },
    dedupMessages(arr) {
      if (!Array.isArray(arr)) return [];
      const seen = new Set();
      const out = [];
      for (let i = 0; i < arr.length; i++) {
        const m = arr[i] || {};
        const key = this.getMsgDedupKey(m);
        if (!key) {
          out.push(m);
          continue;
        }
        if (!seen.has(key)) {
          seen.add(key);
          out.push(m);
        }
      }
      return out;
    },
    auto_grow() {
      const el = document.getElementById("sendtextarea");
      el.style.height = "5px";
      el.style.height = el.scrollHeight + "px";
    },
    selectEmoji(emoji) {
      this.message += emoji.data;
      this.menuEmoji = false;
    },
    openListarTags(chat) {
      if (!chat || !chat.contato || !Array.isArray(chat.contato.tags) || chat.contato.tags.length === 0) {
        this.$vToastify.error("Essa conversa nao possui etiqueta");
        return;
      }

      this.tagsList = chat.contato.tags
        .map((tag) => {
          if (typeof tag === "object") return tag;
          return this.getTagById(tag);
        })
        .filter((tag) => !!tag && !!tag.nome);

      if (this.tagsList.length === 0) {
        this.$vToastify.error("Nao foi possivel identificar as etiquetas desta conversa");
        return;
      }

      this.$modal.show("listarTags");
    },
    openModalImg(url) {
      this.imgmodal = url;
      this.$modal.show("imgModal");
    },
    finalizarConversaPorTag(tags) {
      if (this.finalizarConversa) {
        this.finalizarConversa = !this.finalizarConversa;
      }

      if (!tags) {
        this.finalizarConversa = false;
        return;
      }

      if (tags.length > 0) {
        tags.forEach((tag) => {
          if (tag.etiquetaParaFinalizarConversas) {
            this.finalizarConversa = true;
            return;
          }
        });
      }
    },
    getContaUsuarioId() {
      const user = this.$store.state.user;
      if (!user) return null;

      return !user.operador ? user._id?.toString() : user.usuario?.toString();
    },
    precisaDeEtiquetaParaEncerrar() {
      return this.getContaUsuarioId() === TAG_REQUIRED_CLOSE_USER_ID;
    },
    chatTemEtiqueta(chat) {
      return !!(chat && chat.contato && Array.isArray(chat.contato.tags) && chat.contato.tags.length > 0);
    },
    validarEtiquetaAntesDeEncerrarChat(chat, mensagem = "Selecione uma etiqueta para finalizar a conversa") {
      if (!this.precisaDeEtiquetaParaEncerrar()) {
        return true;
      }

      if (this.chatTemEtiqueta(chat)) {
        return true;
      }

      this.$vToastify.error(mensagem);
      return false;
    },
    getConversasSelecionadasParaEncerrar() {
      const ids = [...new Set([...this.conversasSelecionadas, this.form.chat && this.form.chat._id].filter(Boolean))];

      return ids.map((id) => this.listChats.find((chat) => chat._id === id) || (this.form.chat && this.form.chat._id === id ? this.form.chat : null)).filter(Boolean);
    },
    validarEtiquetaAntesDeEncerrarSelecionadas() {
      if (!this.precisaDeEtiquetaParaEncerrar()) {
        return true;
      }

      const chatsSemEtiqueta = this.getConversasSelecionadasParaEncerrar().filter((chat) => !this.chatTemEtiqueta(chat));

      if (chatsSemEtiqueta.length === 0) {
        return true;
      }

      this.$vToastify.error("Existem conversas selecionadas sem etiqueta. Etiquete as conversas antes de encerrar.");
      return false;
    },
    validarEtiquetaAntesDeEncerrarFiltradas() {
      if (!this.precisaDeEtiquetaParaEncerrar()) {
        return true;
      }

      const chatsSemEtiqueta = this.listChats.filter((chat) => chat.ativo).filter((chat) => !this.chatTemEtiqueta(chat));

      if (chatsSemEtiqueta.length === 0) {
        return true;
      }

      this.$vToastify.error("Existem conversas sem etiqueta nos filtros selecionados. Etiquete as conversas antes de encerrar.");
      return false;
    },
    getVcard(str) {
      const parsed = vCard.parse(str);
      return `*CONTATO*
              ${parsed.n[0].value[1]} ${parsed.n[0].value[0]}
              ${parsed.tel[0].value}`;
    },

    selecionaConversa(chat) {
      if (this.conversasSelecionadas.includes(chat._id)) {
        const index = this.conversasSelecionadas.indexOf(chat._id);
        this.conversasSelecionadas.splice(index, 1);

        return;
      }

      if (this.conversasSelecionadas.length === 10) {
        this.$vToastify.error("Número máximo de conversas selecionadas.");
        return;
      }

      this.conversasSelecionadas.push(chat._id);
    },

    getHtmlFrom(str) {
      return formatarMensagem(str, { quebrarLinhas: false });
    },

    scrollToBottom() {
      setTimeout(() => {
        const container = this.$el.querySelector("#messages");
        container.scrollTop = container.scrollHeight;
      }, 200);
    },
    async scrollChat() {
      if (this.bloqueiaScroll) {
        this.bloqueiaScroll = false;
        return;
      }

      if (Math.abs(this.$refs.scrollchat.scrollHeight - this.$refs.scrollchat.clientHeight - this.$refs.scrollchat.scrollTop) < 20 && this.limit < this.totalChats) {
        this.limit += 15;
        const listReqChats = await this.$http.post(`/v1/${this.route}/list`, this.buildChatListPayload());
        this.listChats = listReqChats.data.data;
        this.setChatListStats(listReqChats.data);
      }
    },

    async checaFiltrosParaFinalizarConversa() {
      const payload = this.buildChatListPayload();
      const filtro = {
        tipo: payload.tipo,
        busca: payload.busca,
        operadorFind: this.operadorFind,
        centrocustoFind: this.centrocustoFind,
        tag: this.tag,
        filtrar: this.filtrar,
        de: this.data.de,
        ate: this.data.ate
      };

      const naoPodeEncerrar = !filtro.tag && !filtro.centrocustoFind && !filtro.operadorFind && !filtro.de && !filtro.ate && !filtro.filtrar && (!filtro.busca || filtro.busca.trim() === "");

      if (naoPodeEncerrar) {
        return this.$vToastify.error("Não é possível encerrar todas as conversas sem aplicar algum filtro!");
      }

      const listReqChats = await this.$http.post(`/v1/${this.route}/list`, payload);

      this.listChats = listReqChats.data.data;
      this.setChatListStats(listReqChats.data);
      this.totalQuePodeSerFinalizado = this.listChats.filter((chat) => chat.ativo).length;

      if (!this.validarEtiquetaAntesDeEncerrarFiltradas()) {
        return;
      }

      if (this.totalQuePodeSerFinalizado < 1) {
        return this.$vToastify.error("Não existem conversas a serem finalizadas");
      }

      this.confirmacao.filtro = filtro;
      this.$modal.show("confirmacaoSenha");
    },

    async confereSenha() {
      if (this.confirmacao.usuario !== this.$store.state.user.email) {
        return this.$vToastify.error("Email ou senha inválidos!");
      }

      const response = await this.$http.post("/confirmaSenhaLZV2", { usuario: this.confirmacao.usuario, senha: this.confirmacao.senha });

      if (!response.data.success) {
        return this.$vToastify.error("Email ou senha inválidos!");
      }

      await this.$modal.hide("confirmacaoSenha");
      await this.encerrarTodasAsConversas();
    },

    async encerrarTodasAsConversas() {
      if (confirm(`Deseja mesmo encerrar todas as conversas? \nNúmero de conversas a serem encerradas: ${this.totalQuePodeSerFinalizado}.\n\nConfira os filtros!`)) {
        const filtro = this.confirmacao.filtro;
        this.confirmacao.senha = "";
        this.confirmacao.usuario = "";

        if (!this.validarEtiquetaAntesDeEncerrarFiltradas()) {
          return;
        }

        const response = await this.$http.post(`/v1/${this.route}/encerrar-conversas`, {
          tipo: filtro.tipo,
          busca: filtro.busca,
          tag: filtro.tag,
          operador: filtro.operadorFind,
          filtrar: filtro.filtrar,
          centrocusto: filtro.centrocustoFind,
          de: filtro.de,
          ate: filtro.ate,
          quantidade: this.totalChats
        });

        if (!response.data.success) {
          return this.$vToastify.error(response.data.err);
        }

        await this.start();

        return this.$vToastify.success("Conversas encerradas com sucesso!");
      }

      return;
    },

    async getMensagens(params) {
      let id = "";

      if (this.$route.params.id && /^[0-9a-fA-F]{24}$/.test(this.$route.params.id)) {
        id = this.$route.params.id;
      } else if (params?.id && /^[0-9a-fA-F]{24}$/.test(params.id)) {
        id = params.id;
      }

      if (id) {
        const listReq = await this.$http.get(`/v1/${this.route}/getMensagens/${id}`);
        this.obj_chat = listReq.data.chat;
        this.list = this.dedupMessages(listReq.data.mensagens);
        this.contact = { ...listReq.data.contato, quemEncerrou: listReq.data.chat.quemEncerrou || "", protocolo: listReq.data.chat.protocolo };
        this.chat = id;
        if (listReq.data && listReq.data.chat && listReq.data.chat.centrocusto) {
          this.centrocusto = listReq.data.chat.centrocusto;
        }
        if (listReq.data && listReq.data.chat && listReq.data.chat.operador) {
          this.operador = listReq.data.chat.operador;
        }
        this.total = this.list.length;

        const idx = this.listChats.map((el) => el._id).indexOf(this.chat.toString());
        if (idx !== -1) {
          const chatAnterior = { ...this.listChats[idx] };
          const chatAtual = { ...listReq.data.chat, naoLidas: 0 };

          this.syncChatStatusCounters(chatAnterior, chatAtual);
          this.$set(this.listChats, idx, chatAtual);
        }

        this.scrollToBottom();
        return listReq.data.chat;
      }
    },
    async start() {
      const listReqChats = await this.$http.post(`/v1/${this.route}/list`, this.buildChatListPayload());

      this.listChats = listReqChats.data.data;
      this.setChatListStats(listReqChats.data);
    },
    limparFiltros() {
      this.operadorFind = null;
      this.centrocustoFind = null;
      this.tag = null;
      this.filtrar = null;
      this.data.de = null;
      this.data.ate = null;
      this.search = "";
      this.limit = 30;
      return this.start();
    },
    async handleFileUpload(ref) {
      if (!this.$refs[ref].files[0]) return;

      let fd = new FormData();

      fd.append("folder", "arquivosWhats");
      fd.append("file", this.$refs[ref].files[0]);

      const resp = await this.$http.post(`/upload`, fd, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      const file = resp.data.file;
      if (!file) {
        this.$vToastify.error("Selecione um arquivo");
        return;
      }

      const sendFile = await this.$http.post(`/v1/${this.route}/send`, {
        chat: this.chat,
        arquivo: file
      });

      if (sendFile.data.err) return this.$vToastify.error(sendFile.data.err);

      this.$refs[ref].value = null;

      const chat = await this.getMensagens();

      const idx = this.listChats.map((el) => el._id).indexOf(this.chat.toString());
      if (idx !== -1) {
        this.listChats[idx] = chat;
        this.listChats.sort((a, b) => {
          return new Date(b.dataMensagem) - new Date(a.dataMensagem);
        });
      }
    },
    async send() {
      if (!this.message) return;

      const EMOJI_RE =
        /[\u00A9\u00AE\u203C\u2049\u2122\u2139\u2194-\u21AA\u231A-\u231B\u2328\u23CF\u23E9-\u23FA\u24C2\u25AA-\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u26FF\u2700-\u27BF\u2934-\u2935\u2B05-\u2B55]|\u200D|\u20E3|\uFE0F|[\u{1F1E6}-\u{1F1FF}]|[\u{1F3FB}-\u{1F3FF}]|[\u{1F300}-\u{1F5FF}]|[\u{1F600}-\u{1F64F}]|[\u{1F680}-\u{1F6FF}]|[\u{1F700}-\u{1F77F}]|[\u{1F780}-\u{1F7FF}]|[\u{1F800}-\u{1F8FF}]|[\u{1F900}-\u{1F9FF}]|[\u{1FA70}-\u{1FAFF}]/u;

      if (this.$store.state.user?.lzv2?.bloquearEmojis && EMOJI_RE.test(this.message)) {
        this.$vToastify.error("Mensagens com emoji não são permitidas.");
        return;
      }

      const req = await this.$http.post(`/v1/${this.route}/send`, {
        chat: this.chat,
        mensagem: this.message
      });

      if (req.data.msg) {
        this.message = "";

        if (this.list && !this.isDuplicateMessage(this.list, req.data.msg)) {
          this.list.push(req.data.msg);
        }
        this.scrollToBottom();

        const idx = this.listChats.map((el) => el._id).indexOf(this.chat.toString());
        if (idx !== -1) {
          this.syncChatStatusCounters(this.listChats[idx], req.data.chat);
          this.listChats[idx] = req.data.chat;
          this.listChats.sort((a, b) => {
            return new Date(b.dataMensagem) - new Date(a.dataMensagem);
          });
        }

        const el = document.getElementById("sendtextarea");
        el.style.height = "50px";
        return;
      }

      this.$vToastify.error(req.data.err);

      const el = document.getElementById("sendtextarea");
      el.style.height = "50px";
    },
    async novaConversa() {
      if (!this.formConversa.telefone) return this.$vToastify.error("Digite o telefone");
      if (!this.formConversa.mensagem) return this.$vToastify.error("Digite a mensagem");

      const req = await this.$http.post(`/v1/${this.route}/novaConversa`, this.formConversa);
      if (req.data.success) {
        this.$vToastify.success("Enviado com sucesso!");
        this.$modal.hide("iniciarConversa");

        this.formConversa.nome = "";
        this.formConversa.telefone = "";
        this.formConversa.mensagem = "";
        this.formConversa.contrato = "";
        this.formConversa.cpf = "";
        this.formConversa.operador = null;
        this.formConversa.tags = [];

        this.start();
      } else {
        this.$vToastify.error(req.data.err);
      }
    },
    async openModalMover(chat) {
      let historico = [];
      try {
        const historyReq = await this.$http.get(`/v1/${this.route}/historico/${chat._id}`);
        historico = historyReq.data.slice(0, 5);
      } catch (e) {
        console.error("Erro ao buscar histórico:", e);
      }
      this.form = {
        chat,
        operador: chat.operador && chat.operador._id ? chat.operador._id : null,
        contato: chat.contato,
        historico: historico
      };

      this.tagModal = this.getTagId(chat && chat.contato && Array.isArray(chat.contato.tags) ? chat.contato.tags[0] : null);
      this.$modal.show("moverConversa");
    },
    async arquivarConversa(usarArrayDeConversas, finalizarPorTags = false) {
      if (!this.form.chat && !usarArrayDeConversas) return this.$vToastify.error("Erro ao encontrar chat");

      if (finalizarPorTags) {
        const _id = this.form.chat._id;
        const quemEncerrou = this.$store.state.user.nome;

        if (!this.validarEtiquetaAntesDeEncerrarChat(this.form.chat)) {
          return;
        }

        const req = await this.$http.post(`/v1/${this.route}/arquivar`, { _id, quemEncerrou });

        if (!req.data.success) {
          this.$vToastify.error(req.data.err);
          return;
        }

        this.$vToastify.success("Finalizado com sucesso!");
        this.$modal.hide("moverConversa");

        return;
      }

      if (!usarArrayDeConversas && confirm("Tem certeza que deseja finalizar está conversa?")) {
        const _id = this.form.chat._id;
        const quemEncerrou = this.$store.state.user.nome;

        if (!this.validarEtiquetaAntesDeEncerrarChat(this.form.chat)) {
          return;
        }

        const req = await this.$http.post(`/v1/${this.route}/arquivar`, { _id, quemEncerrou });

        if (!req.data.success) {
          this.$vToastify.error(req.data.err);
          return;
        }

        this.$vToastify.success("Finalizado com sucesso!");
        this.$modal.hide("moverConversa");
        this.closeChat();

        return;
      }

      if (usarArrayDeConversas && this.conversasSelecionadas.length > 0) {
        if (confirm("Uma ou mais conversas foram marcadas para finalização em lote, deseja continuar?")) {
          if (!this.validarEtiquetaAntesDeEncerrarSelecionadas()) {
            return;
          }

          const erros = [];

          if (this.form.chat._id) this.conversasSelecionadas.push(this.form.chat._id);

          const quemEncerrou = this.$store.state.user.nome;

          this.conversasSelecionadas.forEach(async (conversa, index) => {
            const _id = conversa;
            const response = await this.$http.post(`/v1/${this.route}/arquivar`, { _id, quemEncerrou });

            if (!response.data.success) {
              erros.push(`Houve o(s) seguinte(s) erro(s): ${response.data.err}, para o chat número ${index + 1}`);
            }
          });

          if (erros.length > 0) {
            let mensagem = "";
            erros.forEach((erro) => (mensagem += `${erro}\n`));

            this.$vToastify.error(mensagem);
            return;
          }

          this.conversasSelecionadas = [];
          this.$vToastify.success("Finalizado com sucesso!");
          this.$modal.hide("moverConversa");
          this.closeChat();
        }
      }
    },

    async enviarAvaliacao() {
      if (!this.form.chat) return this.$vToastify.error("Erro ao encontrar chat");

      const req = await this.$http.post(`/v1/operador/avaliacao`, {
        chat: this.form.chat,
        operador: this.form.chat.operador
      });

      if (req.data.success) {
        let link = `https://v2.bestmessage.com.br/avaliacao/${req.data.data._id}`;
        if (this.$store.state.user.lzv2.cliente_trestto) {
          link = `https://uno.trestto.com.br/avaliacao/${req.data.data._id}`;
        }

        const reqSend = await this.$http.post(`/v1/${this.route}/send`, {
          chat: this.form.chat,
          mensagem: `*ATENDIMENTO FINALIZADO*\n\nAvalie nosso atendimento acessando:\n${link}\n\nPara quaisquer outras dúvidas entre em contato novamente obrigado.`
        });

        this.message = "";
        if (reqSend.data.msg) {
          if (this.list) this.list.push(reqSend.data.msg);
          this.scrollToBottom();
        } else {
          this.$vToastify.error(reqSend.data.err);
        }

        this.$vToastify.success("Enviado com sucesso!");
        this.$modal.hide("moverConversa");
      } else {
        this.$vToastify.error(req.data.err);
      }
    },
    async saveChat() {
      if (!this.form.chat) return this.$vToastify.error("Erro ao encontrar chat");

      const selectedTagId = this.getTagId(this.tagModal);
      const contatoPayload = {
        ...this.form.contato,
        tags: selectedTagId ? [selectedTagId] : []
      };

      const req = await this.$http.post(`/v1/${this.route}/saveInfo`, {
        _id: this.form.chat._id,
        contato: contatoPayload
      });

      if (!req.data.success) {
        return this.$vToastify.error(req.data.err);
      }

      this.$modal.hide("moverConversa");
      this.$vToastify.success("Salvo com sucesso!");
      this.config = "info";

      const selectedTag = this.getTagById(selectedTagId);
      const finalizarConversa = selectedTag && selectedTag.etiquetaParaFinalizarConversas === true;

      if (finalizarConversa) {
        this.arquivarConversa(false, true);
      }

      this.closeChat();
    },

    async moverChat() {
      if (!this.$store.state.user.permitirMoverChat) return this.$vToastify.error("Sem premissão para mover a conversa");
      if (!this.form.operador) return this.$vToastify.error("Selecione um operador");
      if (!this.form.chat) return this.$vToastify.error("Erro ao encontrar chat");

      if (this.conversasSelecionadas.length === 0 || (this.conversasSelecionadas.length === 1 && this.conversasSelecionadas.includes(this.form.chat._id))) {
        const req = await this.$http.post(`/v1/${this.route}/moverOperador`, {
          _id: this.form.chat._id,
          operador: this.form.operador
        });

        if (!req.data.success) {
          this.$vToastify.error(req.data.err);
          return;
        }

        this.$vToastify.success("Salvo com sucesso!");
        this.$modal.hide("moverConversa");
        this.config = "info";
        this.closeChat();
        return;
      }

      if (this.conversasSelecionadas.length > 0) {
        if (confirm("Uma ou mais conversas estão selecionadas, deseja mover todas?")) {
          const erros = [];

          if (this.form.chat._id) this.conversasSelecionadas.push(this.form.chat._id);

          this.conversasSelecionadas.forEach(async (conversa) => {
            const _id = conversa;
            const response = await this.$http.post(`/v1/${this.route}/moverOperador`, {
              _id,
              operador: this.form.operador
            });

            if (!response.data.success) {
              erros.push(response.data.err);
              return;
            }
          });

          if (erros.length > 0) {
            let mensagem = "";
            erros.forEach((erro) => (mensagem += `${erro}\n`));
            this.$vToastify.error(mensagem);

            return;
          }

          this.$vToastify.success("Salvo com sucesso!");
          this.$modal.hide("moverConversa");
          this.config = "info";
          this.closeChat();

          return;
        }
      }
    },
    async closeChat() {
      this.$router.push({ path: `/chat` });
      const listReqChats = await this.$http.post(`/v1/${this.route}/list`, this.buildChatListPayload());

      this.listChats = listReqChats.data.data;
      this.setChatListStats(listReqChats.data);

      this.chat = false;
      this.contact = false;
      this.list = [];
      this.total = 0;
    },

    async toggleRecording() {
      if (this.isRecording) {
        this.stopRecording();
      } else {
        await this.startRecording();
      }
    },

    async startRecording() {
      try {
        this.audioChunks = [];
        this.mediaStream = await navigator.mediaDevices.getUserMedia({ audio: true });
        this.mediaRecorder = new MediaRecorder(this.mediaStream);

        this.mediaRecorder.ondataavailable = (event) => {
          this.audioChunks.push(event.data);
        };

        this.mediaRecorder.onstop = () => {
          this.audioBlob = new Blob(this.audioChunks, { type: "audio/ogg" });
          this.audioUrl = URL.createObjectURL(this.audioBlob);

          this.stopMicrophone();
          this.sendAudio();
        };

        this.mediaRecorder.start();
        this.isRecording = true;
      } catch (err) {
        console.error("Erro ao iniciar a gravação:", err);
      }
    },

    stopRecording() {
      this.mediaRecorder.stop();
      this.isRecording = false;
      this.stopMicrophone();
    },
    stopMicrophone() {
      if (this.mediaStream) {
        this.mediaStream.getTracks().forEach((track) => track.stop());
        this.mediaStream = null;
      }
    },
    async sendAudio() {
      if (!this.audioBlob) return;

      try {
        const formData = new FormData();
        formData.append("file", this.audioBlob);
        formData.append("folder", "arquivosWhats");

        const response = await this.$http.post(`/upload`, formData, {
          headers: { "Content-Type": "multipart/form-data" }
        });

        const fileresp = response.data.file;

        const sendFile = await this.$http.post(`/v1/${this.route}/send`, {
          chat: this.chat,
          arquivo: fileresp
        });

        if (sendFile.data.err) return this.$vToastify.error(sendFile.data.err);

        const chat = await this.getMensagens();

        const idx = this.listChats.map((el) => el._id).indexOf(this.chat.toString());
        if (idx !== -1) {
          this.listChats[idx] = chat;
          this.listChats.sort((a, b) => {
            return new Date(b.dataMensagem) - new Date(a.dataMensagem);
          });
        }
      } catch (err) {
        // ignore error
      }
    }
  },

  async beforeRouteUpdate(to, from, next) {
    next();
    await this.getMensagens();
  },
  async beforeRouteLeave(to, from, next) {
    next();
    await this.getMensagens(to.params);
  },
  async beforeMount() {
    await this.start();
    await this.getMensagens();

    const operadoresReq = await this.$http.post("/v1/operador/list", { all: true, chatAcesso: true });
    this.operadores = operadoresReq.data.data;

    const centrocustoReq = await this.$http.post("/v1/centrocusto/list", { all: true });
    this.centrocustos = centrocustoReq.data.data;

    const tagReq = await this.$http.post("/v1/tag/list", { all: true });
    this.tags = tagReq.data.data;

    const responseNumeros = await this.$http.post("/v1/numeros/list", { ativo: true });
    this.numeros = responseNumeros.data.list;

    const responsePreMensagens = await this.$http.post("/v1/preMensagem/list");

    this.preMensagens = responsePreMensagens.data.data;
  },

  mounted() {
    if (!this.$store.state.user || !this.$store.state.user._id) return;

    const id_usuario = !this.$store.state.user.operador ? this.$store.state.user._id.toString() : this.$store.state.user.usuario.toString();

    this.sockets.subscribe(`msgV2-${id_usuario}`, async function (msg) {
      if (
        (!this.$store.state.user.operador && msg.usuario && msg.usuario._id.toString() !== this.$store.state.user._id.toString()) ||
        (this.$store.state.user.operador && msg.usuario && msg.usuario._id.toString() !== this.$store.state.user.usuario.toString())
      )
        return;

      if (msg.chat.toString() === this.chat.toString()) {
        this.bloqueiaScroll = true;
        if (!this.isDuplicateMessage(this.list, msg)) {
          this.list.push(msg);
          this.scrollToBottom();
        }
      }

      const idx = this.listChats.map((el) => el._id.toString()).indexOf(msg.chat.toString());
      if (idx !== -1) {
        const chatAtual = {
          ...this.listChats[idx],
          dataMensagem: moment().toDate(),
          ultimaMensagem: msg.mensagem ? msg.mensagem : "",
          ultimoAResponder: "Cliente",
          naoLidas: this.listChats[idx].naoLidas + 1
        };

        this.syncChatStatusCounters(this.listChats[idx], chatAtual);
        this.$set(this.listChats, idx, chatAtual);
        this.listChats = this.listChats.sort((a, b) => {
          return new Date(b.dataMensagem) - new Date(a.dataMensagem);
        });
      } else {
        if (msg.operador && msg.operador._id.toString() === this.$store.state.user._id.toString()) {
          await this.start();
        }
      }
    });
    this.sockets.subscribe(`msgV2-update-${id_usuario}`, function (msg) {
      if (msg && msg.chat.toString() === this.chat.toString()) {
        const idx = this.list.map((el) => el._id.toString()).indexOf(msg._id.toString());
        if (idx !== -1) {
          this.bloqueiaScroll = true;
          this.$set(this.list, idx, msg);
        }
      }
    });
  },
  beforeDestroy() {
    if (!this.$store.state.user || !this.$store.state.user._id) return;
    const id_usuario = !this.$store.state.user.operador ? this.$store.state.user._id.toString() : this.$store.state.user.usuario.toString();
    this.sockets.unsubscribe(`msgV2-${id_usuario}`);
    this.sockets.unsubscribe(`msgV2-update-${id_usuario}`);
  }
};
</script>

<style scoped>
#menu {
  display: none;
}

.chat-page {
  --chat-primary: #2563eb;
  --chat-primary-dark: #1d4ed8;
  --chat-primary-soft: #eff6ff;
  --chat-surface: #ffffff;
  --chat-surface-soft: #f8fafc;
  --chat-border: #e5e7eb;
  --chat-border-strong: #cbd5e1;
  --chat-text: #0f172a;
  --chat-muted: #64748b;
  --chat-muted-2: #94a3b8;
  --chat-success: #16a34a;
  --chat-warning: #d97706;
  --chat-danger: #dc2626;
  --chat-radius: 22px;
  --chat-panel-height: calc(100vh - 214px);
  min-height: calc(100vh - 24px);
  padding: 30px 38px;
  color: var(--chat-text);
  background: #f3f4f6;
}

.chat-page * {
  box-sizing: border-box;
}

.chat-page-header {
  display: grid;
  grid-template-columns: minmax(280px, 440px) 1fr;
  gap: 20px;
  align-items: end;
  margin-bottom: 18px;
}

.chat-page-header h1 {
  margin: 0;
  font-size: 30px;
}

.chat-page-header p {
  margin-top: 8px;
  max-width: 620px;
  color: var(--chat-muted);
  line-height: 1.55;
}

.chat-header-actions {
  display: flex;
  align-items: stretch;
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: wrap;
}

.chat-new-conversation-button {
  align-self: flex-end;
  position: relative;
  top: 0;
}

.chat-stat-card,
.chat-sidebar,
.chat-main-card,
.chat-list-item,
.chat-icon-button,
.chat-modal {
  backdrop-filter: blur(10px);
}

.chat-stat-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 132px;
  min-height: 58px;
  border: 1px solid rgba(226, 232, 240, 0.86);
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.88);
  padding: 11px 14px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
}

.chat-stat-card span {
  margin-bottom: 6px;
  color: var(--chat-muted);
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.chat-stat-card strong {
  color: var(--chat-text);
  font-size: 23px;
  font-weight: 800;
  line-height: 1;
}

.chat-stat-card--pending {
  border-color: rgba(251, 191, 36, 0.42);
  background: linear-gradient(135deg, #fff7ed 0%, #fffbeb 100%);
}

.chat-stat-card--pending span,
.chat-stat-card--pending strong {
  color: #92400e;
}

.chat-stat-card--answered {
  border-color: rgba(34, 197, 94, 0.35);
  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);
}

.chat-stat-card--answered span,
.chat-stat-card--answered strong {
  color: #166534;
}

.chat-layout {
  display: grid;
  grid-template-columns: 410px minmax(0, 1fr);
  gap: 18px;
  min-height: var(--chat-panel-height);
}

.chat-sidebar-shell,
.chat-main-shell {
  min-width: 0;
  position: relative;
}

.chat-sidebar-shell::after,
.chat-main-shell::after {
  content: "";
  position: absolute;
  left: 7%;
  right: 7%;
  bottom: -20px;
  height: 40px;
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.24);
  filter: blur(18px);
  pointer-events: none;
  z-index: 0;
}

.chat-sidebar,
.chat-main-card {
  position: relative;
  z-index: 1;
  height: var(--chat-panel-height);
  border: 1px solid rgba(226, 232, 240, 0.94);
  border-radius: var(--chat-radius);
  background: linear-gradient(180deg, #f8fbfe 0%, #eef6fb 100%); /* subtle bluish gradient to match design */
  box-shadow: 0 28px 52px -26px rgba(15, 23, 42, 0.22), 0 14px 22px -16px rgba(15, 23, 42, 0.16), 0 3px 8px rgba(15, 23, 42, 0.08);
  transform: translateY(-1px);
}

.chat-sidebar {
  overflow-y: auto;
  overflow-x: hidden;
}

.chat-main-card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  overflow: hidden;
}

.chat-sidebar::-webkit-scrollbar,
#messages::-webkit-scrollbar {
  width: 8px;
}

.chat-sidebar::-webkit-scrollbar-track,
#messages::-webkit-scrollbar-track {
  background: transparent;
}

.chat-sidebar::-webkit-scrollbar-thumb,
#messages::-webkit-scrollbar-thumb {
  border: 2px solid transparent;
  border-radius: 999px;
  background: #cbd5e1;
  background-clip: content-box;
}

.chat-mobile-new-button {
  display: none;
}

.chat-filter-card {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  padding: 22px 18px 18px;
  border-bottom: 1px solid #eef2f7;
  background: linear-gradient(180deg, rgba(248, 250, 252, 0.9) 0%, rgba(255, 255, 255, 0.9) 100%);
}

.filter-heading {
  grid-column: 1 / -1;
  display: flex;
  align-items: center;
  gap: 12px;
}

.filter-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 14px;
  background: var(--chat-primary-soft);
  color: var(--chat-primary);
}

.filter-heading h2,
.chat-list-heading h2 {
  margin: 0;
  color: var(--chat-text);
  font-size: 14px;
  font-weight: 800;
}

.filter-heading span {
  display: block;
  margin-top: 3px;
  color: var(--chat-primary);
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.filter-copy,
.chat-list-heading p {
  margin: 0;
  color: var(--chat-muted);
  font-size: 12px;
  line-height: 1.45;
}

.filter-copy,
.filter-search-label,
.chat-filter-card > .grid,
.filter-actions {
  grid-column: 1 / -1;
}

.filter-search-label {
  margin-bottom: -7px !important;
  color: var(--chat-muted);
}

.chat-filter-card label,
.chat-modal label {
  display: block;
  margin-bottom: 7px;
  color: #334155 !important;
  font-size: 12.5px;
  font-weight: 700;
}

.chat-filter-card > .mb-1,
.chat-filter-card > .mb-2,
.chat-filter-card > .grid {
  margin-bottom: 0;
}

.chat-filter-card .grid {
  gap: 10px !important;
}

.chat-status-control {
  width: 100%;
  min-height: 43px;
  padding: 0 14px;
  border: 1px solid var(--chat-border) !important;
  border-radius: 13px !important;
  background: #ffffff !important;
  color: #334155;
  font-size: 13px;
  font-weight: 500;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  outline: none;
  transition: border-color 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}

select.chat-status-control {
  padding-right: 38px;
  appearance: none;
}

.chat-status-control:focus {
  border-color: var(--chat-border) !important;
  box-shadow: 0 0 0 2px rgb(219 234 254 / 1), 0 1px 2px rgba(15, 23, 42, 0.04) !important;
}

.chat-status-control[type="date"] {
  text-align: center;
}

.chat-status-control::placeholder,
.chat-filter-card input::placeholder,
.chat-modal input::placeholder,
.chat-modal textarea::placeholder {
  font-size: 12px;
  color: #6b7280; /* tom neutro */
}

.chat-filter-card input,
.chat-filter-card select,
.chat-modal input,
.chat-modal select,
.chat-modal textarea {
  width: 100%;
  min-height: 43px;
  border: 1px solid var(--chat-border) !important;
  border-radius: 13px !important;
  background: #ffffff !important;
  color: #334155;
  font-size: 13px;
  font-weight: 500;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  outline: none;
  transition: border-color 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}

.chat-status-control option {
  font-size: 12px;
}

.chat-filter-card input,
.chat-modal input {
  padding: 0 14px;
}

.chat-filter-card select,
.chat-modal select {
  padding: 0 38px 0 14px;
}

.chat-filter-card input:focus,
.chat-filter-card select:focus,
.chat-modal input:focus,
.chat-modal select:focus,
.chat-modal textarea:focus {
  border-color: var(--chat-border) !important;
  box-shadow: 0 0 0 2px rgb(219 234 254 / 1), 0 1px 2px rgba(15, 23, 42, 0.04) !important;
}

.chat-filter-card input::placeholder,
.chat-filter-card textarea::placeholder {
  color: #cbd5e1 !important;
  opacity: 1;
  font-weight: 400 !important;
}

.chat-filter-card .chat-status-control.is-placeholder {
  color: #94a3b8 !important;
  font-weight: 400 !important;
}

.chat-filter-card input[type="date"].is-placeholder::-webkit-datetime-edit {
  color: #94a3b8 !important;
}

.chat-filter-card [type="date"] {
  text-align: center;
}

.select-icon {
  position: absolute;
  right: 13px;
  top: 50%;
  pointer-events: none;
  color: var(--chat-muted-2);
  transform: translateY(-50%);
  transition: transform 0.18s ease, color 0.18s ease;
}

.group:focus-within .select-icon {
  color: var(--chat-primary);
  transform: translateY(-50%) rotate(180deg);
}

.filter-actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-top: 4px;
}

.filter-actions button {
  min-height: 42px;
  border-radius: 13px !important;
  box-shadow: none !important;
}

.filter-actions button:nth-child(3) {
  grid-column: 1 / -1;
}

.chat-list-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 18px 10px;
  border-bottom: 1px solid #eef2f7;
}

.chat-list-heading p {
  margin-top: 5px;
}

.chat-list-heading span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 29px;
  height: 29px;
  border-radius: 999px;
  background: var(--chat-primary-soft);
  color: var(--chat-primary-dark);
  font-size: 12px;
  font-weight: 800;
}

.chat-list-item {
  margin: 10px 12px 0 !important;
  padding: 0 !important;
  border: 1px solid var(--chat-border) !important;
  border-radius: 18px !important;
  background: #ffffff !important;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.045);
  transition: border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease, background 0.18s ease;
}

.chat-list-item:hover {
  transform: translateY(-1px);
  border-color: #bfdbfe !important;
  box-shadow: 0 14px 30px rgba(15, 23, 42, 0.08);
}

.chat-list-item--unread {
  border-color: #dbe4f0 !important;
  background: #e6eefb !important;
}

.chat-list-item--selected {
  border-color: #93c5fd !important;
  background: #eff6ff !important;
  box-shadow: 0 14px 30px rgba(37, 99, 235, 0.12);
}

.conversation-card-link {
  position: relative;
  display: block;
  width: 100%;
  padding: 13px;
  color: inherit;
  text-decoration: none;
}

.conversation-card-top {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.conversation-card-main {
  flex: 1;
  min-width: 0;
}

.conversation-name-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-width: 0;
}

.conversation-name-row strong {
  overflow: hidden;
  color: #0f172a;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.conversation-time {
  flex-shrink: 0;
  padding: 3px 8px;
  border-radius: 8px;
  background: #f8fafc;
  color: #64748b;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.conversation-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  overflow: hidden;
  margin-top: 4px;
  color: var(--chat-muted);
  font-size: 11px;
}

.conversation-meta span {
  display: inline-flex;
  min-width: 0;
  overflow: hidden;
  color: #64748b;
  font-size: 11px;
  font-weight: 500;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.conversation-card-bottom {
  display: grid;
  gap: 9px;
  margin-top: 10px;
  padding-left: 56px;
}

.conversation-card-bottom p {
  display: -webkit-box;
  min-height: 34px;
  margin: 0;
  overflow: hidden;
  color: #334155;
  font-size: 12.5px;
  line-height: 1.45;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.conversation-card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-height: 28px;
}

.conversation-card-actions,
.conversation-card-tools {
  display: flex;
  align-items: center;
  gap: 6px;
}

.conversation-status {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  border-radius: 999px;
  padding: 0 10px;
  font-size: 11px;
  font-weight: 800;
}

.conversation-status--answered {
  background: #dcfce7;
  color: #166534;
}

.conversation-status--pending {
  background: #fef3c7;
  color: #92400e;
}

.conversation-status--closed {
  background: #e2e8f0;
  color: #475569;
}

.conversation-card-tools button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 1px solid var(--chat-border);
  border-radius: 999px;
  background: #ffffff;
  color: #475569;
  box-shadow: 0 5px 13px rgba(15, 23, 42, 0.08);
}

.conversation-card-tool--disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.chat-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 16px;
  background: linear-gradient(135deg, #e0ecff 0%, #f8fbff 100%);
  color: #1e3a8a;
  font-weight: 800;
  object-fit: cover;
}

.chat-avatar--small {
  width: 43px;
  height: 43px;
  font-size: 14px;
}

.chat-avatar--large {
  width: 50px;
  height: 50px;
  border-radius: 18px;
  font-size: 15px;
}

.chat-contact-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 78px;
  gap: 14px;
  padding: 13px 16px;
  border-bottom: 1px solid #eef2f7;
  background: rgba(255, 255, 255, 0.96);
}

.chat-contact-summary {
  min-width: 0;
}

.chat-contact-name-row {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.chat-contact-name-row strong {
  overflow: hidden;
  color: #08111f;
  font-size: 17px;
  font-weight: 850;
  letter-spacing: -0.01em;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.chat-contact-name-row span {
  flex-shrink: 0;
  border-radius: 999px;
  background: #dcfce7;
  color: #166534;
  padding: 6px 11px;
  font-size: 11px;
  font-weight: 800;
}

.chat-contact-name-row span.is-closed {
  background: #e2e8f0;
  color: #475569;
}

.chat-contact-meta-row {
  display: flex;
  flex-wrap: wrap;
  gap: 7px 14px;
  margin-top: 8px;
  color: var(--chat-muted);
  font-size: 12px;
}

.chat-contact-meta-row b {
  color: var(--chat-text);
  font-weight: 800;
}

.chat-contact-actions {
  display: flex;
  align-items: center;
  gap: 9px;
}

.chat-icon-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border: 1px solid var(--chat-border);
  border-radius: 15px;
  background: #ffffff;
  color: #334155;
  box-shadow: 0 6px 15px rgba(15, 23, 42, 0.06);
  transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}

.chat-icon-button:hover {
  transform: translateY(-1px);
  background: var(--chat-surface-soft);
  box-shadow: 0 10px 20px rgba(15, 23, 42, 0.09);
}

#messages {
  flex: 1 1 auto;
  height: auto !important;
  min-height: 0;
  padding: 24px 18px 18px !important;
  background: radial-gradient(circle at 8% 8%, rgba(37, 99, 235, 0.08), transparent 28%), radial-gradient(circle at 92% 12%, rgba(20, 184, 166, 0.08), transparent 28%),
    linear-gradient(135deg, #f8fbff 0%, #f4f8ff 55%, #f8fafc 100%) !important;
}

#messages .chat-message {
  margin-bottom: 7px;
}

#messages .max-w-xs {
  max-width: min(540px, 72vw);
}

#messages .inline-block {
  border-radius: 20px !important;
  padding: 12px 15px !important;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.08);
}

#messages .bg-chat-me {
  background: linear-gradient(135deg, var(--chat-primary) 0%, #1d4ed8 100%) !important;
  color: #ffffff !important;
}

#messages .bg-white {
  background: #ffffff !important;
  color: #243145 !important;
}

#messages .float-right {
  display: block;
  margin-top: 8px;
  color: inherit;
  opacity: 0.72;
  font-size: 10px;
}

.break-line {
  white-space: pre-wrap;
  word-wrap: break-word;
}

.chat-main-card > .border-t-2 {
  border-top: 1px solid #eef2f7 !important;
  padding: 11px !important;
  background: #ffffff;
}

.chat-main-card > .border-t-2 > div {
  border: 1px solid var(--chat-border);
  border-radius: 24px;
  padding: 8px;
  background: #ffffff;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);
}

.chat-composer {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 50px;
  width: 100%;
}

.chat-composer-left,
.chat-composer-right {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.chat-composer-left {
  order: 1;
}

.chat-message-input {
  order: 2;
  flex: 1 1 auto;
  min-width: 0;
}

.chat-composer-right {
  order: 3;
}

.chat-composer-action {
  width: 39px !important;
  height: 39px !important;
  margin-left: 0 !important;
  flex-shrink: 0;
  color: #64748b !important;
}

.chat-composer-action:hover {
  background: #f1f5f9 !important;
}

.chat-composer-send {
  width: 44px !important;
  height: 44px !important;
  flex-shrink: 0;
  background: var(--chat-primary) !important;
  box-shadow: 0 10px 20px rgba(37, 99, 235, 0.24);
}

#sendtextarea {
  min-height: 48px !important;
  max-height: 110px !important;
  padding: 13px 16px !important;
  border: 1px solid transparent !important;
  border-radius: 999px !important;
  background: #f8fafc !important;
  color: #334155 !important;
  line-height: 22px !important;
  box-shadow: inset 0 0 0 1px #e2e8f0 !important;
}

#sendtextarea:focus {
  background: #ffffff !important;
  box-shadow: inset 0 0 0 1px #93c5fd, 0 0 0 4px rgba(37, 99, 235, 0.1) !important;
}

.chat-empty-state {
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  padding: 32px;
  color: var(--chat-muted);
}

.chat-empty-icon {
  width: 82px;
  height: 82px;
  border-radius: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--chat-primary-soft);
  color: var(--chat-primary);
  margin-bottom: 18px;
  box-shadow: 0 18px 34px rgba(37, 99, 235, 0.13);
}

.chat-empty-state h2 {
  margin: 0;
  color: #08111f;
  font-size: 22px;
  font-weight: 850;
  letter-spacing: -0.02em;
}

.chat-empty-state p {
  max-width: 380px;
  margin-top: 10px;
  font-size: 14px;
  line-height: 1.6;
}

::v-deep .v--modal-overlay {
  background: rgba(15, 23, 42, 0.54) !important;
  backdrop-filter: blur(8px);
}

::v-deep .v--modal-box,
::v-deep .chat-rounded-modal,
::v-deep .v--modal {
  overflow: hidden !important;
  border-radius: 26px !important;
  background: transparent !important;
  box-shadow: 0 26px 90px rgba(15, 23, 42, 0.3) !important;
}

.chat-modal {
  overflow: hidden;
  border: 1px solid rgba(226, 232, 240, 0.9);
  border-radius: 26px !important;
  background: #ffffff;
}

.chat-modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  padding: 21px 24px 17px;
  border-bottom: 1px solid #eef2f7;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
}

.chat-modal-header h2 {
  margin: 0;
  color: #08111f;
  font-size: 20px;
  font-weight: 850;
  letter-spacing: -0.02em;
}

.chat-modal-header p {
  margin: 7px 0 0;
  color: var(--chat-muted);
  font-size: 13.5px;
  line-height: 1.5;
}

.chat-modal-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 1px solid var(--chat-border);
  border-radius: 15px;
  background: #ffffff;
  color: #ffffff;
  box-shadow: 0 6px 14px rgba(15, 23, 42, 0.06);
}

.chat-modal form > .grid,
.chat-modal > div:not(.chat-modal-header):not(.chat-modal-tabs) {
  padding: 22px 24px;
}

.chat-modal form > .grid {
  row-gap: 18px !important;
  column-gap: 16px !important;
}

.chat-modal textarea {
  min-height: 108px;
  padding: 12px 16px !important;
  border-radius: 15px !important;
  line-height: 1.5;
  resize: vertical;
}

.chat-modal input[type="checkbox"] {
  width: 18px !important;
  min-height: 18px !important;
  height: 18px !important;
  padding: 0 !important;
  border: 1px solid var(--chat-border-strong) !important;
  border-radius: 6px !important;
  box-shadow: none !important;
  cursor: pointer;
  flex-shrink: 0;
}

.predefined-message-toggle {
  display: inline-flex !important;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-bottom: 0 !important;
  color: #334155 !important;
  white-space: nowrap;
}

.predefined-message-toggle span {
  font-size: 14px;
}

.chat-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 8px;
  padding-top: 18px;
  border-top: 1px solid #eef2f7;
}

.chat-modal-tabs {
  padding: 12px 24px;
  border-bottom: 1px solid #eef2f7;
  background: #f8fafc;
  overflow-x: auto;
}

.chat-modal-tabs label {
  display: inline-flex;
  align-items: center;
  min-height: 36px;
  padding: 0 12px !important;
  border: 0 !important;
  border-radius: 11px !important;
  color: #475569 !important;
  font-size: 13px !important;
  font-weight: 800 !important;
  white-space: nowrap;
}

.chat-modal-tabs label.bg-blue-50,
.chat-modal-tabs label.text-blue-700 {
  background: var(--chat-primary-soft) !important;
  color: var(--chat-primary-dark) !important;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);
}

.chat-modal .bg-green-500,
.chat-modal .bg-green-600 {
  background: var(--chat-success) !important;
}

.chat-modal .bg-red-500,
.chat-modal .bg-red-600,
.chat-modal .bg-red-700 {
  background: var(--chat-danger) !important;
}

@media (max-width: 1180px) {
  .chat-page {
    padding: 24px;
  }

  .chat-layout {
    grid-template-columns: 330px minmax(0, 1fr);
  }

  .chat-header-actions {
    justify-content: flex-end;
  }

  .chat-stat-card {
    width: 120px;
  }
}

@media (max-width: 767px) {
  .chat-page {
    --chat-panel-height: calc(100vh - 150px);
    padding: 16px 12px;
  }

  .chat-page-header {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 14px;
  }

  .chat-page-header h1 {
    font-size: 26px;
  }

  .chat-header-actions {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .chat-new-conversation-button {
    grid-column: 1 / -1;
    top: 0;
  }

  .chat-stat-card {
    width: auto;
    min-width: 0;
  }

  .chat-layout {
    display: block;
    min-height: auto;
  }

  .chat-sidebar,
  .chat-main-card {
    height: var(--chat-panel-height);
    background: linear-gradient(180deg, #f8fbfe 0%, #eef6fb 100%);
  }

  .chat-filter-card {
    grid-template-columns: 1fr;
  }

  .filter-actions {
    grid-template-columns: 1fr;
  }

  .chat-contact-header {
    min-height: 74px;
    padding-right: 58px;
  }

  .chat-contact-actions {
    display: none;
  }

  .chat-contact-meta-row {
    display: none;
  }

  #messages .max-w-xs {
    max-width: 82vw;
  }

  .chat-composer {
    gap: 5px;
  }

  .chat-composer-action {
    width: 36px !important;
    height: 36px !important;
  }

  .chat-composer-send {
    width: 40px !important;
    height: 40px !important;
  }

  .chat-modal-header,
  .chat-modal form > .grid,
  .chat-modal > div:not(.chat-modal-header):not(.chat-modal-tabs) {
    padding-left: 18px;
    padding-right: 18px;
  }
}

.chat-page {
  background: #f3f4f6;
  color: #334155;
}

.chat-page-header p {
  color: #64748b !important;
  font-weight: 400 !important;
  line-height: 1.6;
}

.chat-stat-card {
  border-color: #edf2f7;
  background: rgba(255, 255, 255, 0.86);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(10px);
}

.chat-stat-card span {
  font-weight: 400;
  letter-spacing: 0.02em;
  color: #94a3b8;
}

.chat-stat-card strong {
  font-weight: 500;
  color: #1e293b;
}

.chat-stat-card--pending,
.chat-stat-card--answered {
  border-color: #edf2f7;
  background: rgba(255, 255, 255, 0.86);
}

.chat-stat-card--pending span,
.chat-stat-card--answered span {
  color: #94a3b8;
}

.chat-stat-card--pending strong {
  color: #ea580c;
}

.chat-stat-card--answered strong {
  color: #2563eb;
}

.chat-sidebar,
.chat-main-card {
  border-color: #edf2f7;
  border-radius: 24px;
  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.055);
  background: linear-gradient(180deg, #f8fbfe 0%, #eef6fb 100%);
}

.filter-heading h2,
.chat-list-heading h2 {
  font-weight: 500;
  color: #1e293b;
}

.filter-heading span {
  font-weight: 400;
  letter-spacing: 0;
  text-transform: none;
  color: #94a3b8;
}

.filter-copy,
.chat-list-heading p,
.conversation-meta,
.chat-contact-meta-row {
  color: #64748b;
  font-weight: 400;
}

.conversation-meta span,
.conversation-meta b {
  color: #64748b;
}

.chat-filter-card label,
.chat-modal label {
  font-weight: 500 !important;
  color: #374151 !important;
}

.chat-filter-card input,
.chat-filter-card select,
.chat-modal input,
.chat-modal select,
.chat-modal textarea {
  border-color: var(--chat-border) !important;
  background: #ffffff !important;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
  color: #334155 !important;
  font-weight: 500 !important;
}

.chat-filter-card input:focus,
.chat-filter-card select:focus,
.chat-modal input:focus,
.chat-modal select:focus,
.chat-modal textarea:focus {
  border-color: var(--chat-border) !important;
  box-shadow: 0 0 0 2px rgb(219 234 254 / 1), 0 1px 2px rgba(15, 23, 42, 0.04) !important;
}

.chat-filter-card input::placeholder,
.chat-filter-card textarea::placeholder {
  color: #cbd5e1 !important;
  opacity: 1;
  font-weight: 400 !important;
}

.chat-filter-card .chat-status-control.is-placeholder {
  color: #94a3b8 !important;
  font-weight: 400 !important;
}

.chat-filter-card input[type="date"].is-placeholder::-webkit-datetime-edit {
  color: #94a3b8 !important;
}

.predefined-message-toggle input[type="checkbox"] {
  accent-color: #2563eb !important;
  border-color: #94a3b8 !important;
  width: 18px;
  height: 18px;
  cursor: pointer;
  flex-shrink: 0;
}

.predefined-message-toggle input[type="checkbox"]:checked {
  background-color: #2563eb !important;
  border-color: #2563eb !important;
  accent-color: #2563eb !important;
}

.predefined-message-toggle span {
  color: #475569;
}

.filter-actions button,
.chat-modal-actions button,
.chat-modal button,
.chat-composer-send {
  font-weight: 500 !important;
  box-shadow: none !important;
}

.filter-actions button.bg-blue-500,
.chat-modal button.bg-blue-500,
.chat-modal .bg-blue-500,
.chat-composer-send {
  background: #3b82f6 !important;
}

.filter-actions button.bg-blue-500:hover,
.chat-modal button.bg-blue-500:hover,
.chat-modal .bg-blue-500:hover,
.chat-composer-send:hover {
  background: #2563eb !important;
}

.chat-modal .bg-green-500,
.chat-modal .bg-green-600,
.chat-modal .bg-green-700 {
  background: #3b82f6 !important;
}

.chat-modal .bg-green-500:hover,
.chat-modal .bg-green-600:hover,
.chat-modal .bg-green-700:hover {
  background: #1d4ed8 !important;
}

.chat-list-heading {
  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
}

.chat-list-heading span {
  background: #eff6ff;
  color: #2563eb;
  font-weight: 500;
}

.chat-list-item {
  border-color: #eef2f7 !important;
  background: #ffffff !important;
  box-shadow: none !important;
}

.chat-list-item:hover {
  border-color: #dbeafe !important;
  background: #fbfdff !important;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.045) !important;
  transform: translateY(-1px);
}

.chat-list-item--unread {
  border-color: #dbe4f0 !important;
  background: #e6eefb !important;
}

.chat-list-item--selected {
  border-color: #bfdbfe !important;
  background: #f8fbff !important;
  box-shadow: 0 10px 24px rgba(37, 99, 235, 0.07) !important;
}

.conversation-name-row strong {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
}

.conversation-time {
  color: #64748b;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}

.conversation-meta span {
  color: #64748b;
}

.conversation-card-bottom p {
  color: #64748b;
  font-weight: 400;
}

.conversation-status {
  font-weight: 400;
  border: 1px solid transparent;
}

.conversation-status--answered {
  background: #eff6ff;
  color: #2563eb;
  border-color: #dbeafe;
}

.conversation-status--pending {
  background: #fff7ed;
  color: #ea580c;
  border-color: #fed7aa;
}

.conversation-status--closed {
  background: #f1f5f9;
  color: #64748b;
  border-color: #e2e8f0;
}

.conversation-card-tools button,
.chat-icon-button,
.chat-composer-action {
  box-shadow: none !important;
  border-color: #e5eaf0;
}

.conversation-card-tools button:hover,
.chat-icon-button:hover,
.chat-composer-action:hover {
  background: #eff6ff;
  border-color: #bfdbfe;
  color: #2563eb;
}

.chat-avatar {
  background: #eff6ff;
  color: #2563eb;
  font-weight: 500;
}

.chat-contact-header {
  background: rgba(255, 255, 255, 0.96);
}

.chat-contact-name-row strong {
  font-weight: 500;
  color: #1e293b;
}

.chat-contact-name-row span {
  background: #eff6ff;
  color: #2563eb;
  font-weight: 400;
  border: 1px solid #dbeafe;
}

.chat-contact-name-row span.is-closed {
  background: #f1f5f9;
  color: #64748b;
  border-color: #e2e8f0;
}

.chat-contact-meta-row b {
  font-weight: 500;
  color: #334155;
}

#messages {
  background: linear-gradient(180deg, #eef4fb 0%, #e6eef8 100%) !important;
}

#messages .inline-block {
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.06) !important;
  border: 1px solid rgba(226, 232, 240, 0.9);
  font-weight: 400;
  border-radius: 18px !important;
}

#messages .bg-chat-me {
  background: #2563eb !important;
  color: #ffffff !important;
  border-color: #2563eb !important;
  box-shadow: 0 8px 22px rgba(37, 99, 235, 0.12) !important;
}

#messages .bg-white {
  background: #ffffff !important;
  color: #334155 !important;
  box-shadow: 0 6px 14px rgba(15, 23, 42, 0.04) !important;
}

#messages strong,
.chat-message strong {
  font-weight: 500;
}

#messages .float-right {
  font-weight: 400;
  opacity: 0.62;
}

.chat-main-card > .border-t-2 {
  background: rgba(255, 255, 255, 0.96);
}

.chat-main-card > .border-t-2 > div {
  border-color: #e5eaf0;
  box-shadow: none;
  background: #ffffff;
}

#sendtextarea {
  background: #f8fafc !important;
  color: #334155 !important;
  font-weight: 400;
}

.chat-modal-header h2 {
  font-weight: 500;
  color: #1e293b;
}

.chat-modal-header p {
  color: #64748b;
  font-weight: 400;
}

.chat-modal-tabs label {
  font-weight: 400 !important;
}

.chat-modal-tabs label.bg-blue-50,
.chat-modal-tabs label.text-blue-700 {
  color: #2563eb !important;
}

a[href*="downloadConversa"] {
  color: #16a34a !important;
  border-color: #bbf7d0 !important;
  box-shadow: none !important;
}

a[href*="downloadConversa"] svg {
  color: #16a34a !important;
}

.font-bold {
  font-weight: 500 !important;
}

.font-semibold {
  font-weight: 500 !important;
}

.chat-page h1,
.filter-heading h2,
.chat-list-heading h2,
.conversation-name-row strong,
.chat-contact-name-row strong,
.chat-empty-state h2,
.chat-modal-header h2 {
  color: #475569 !important;
}

.chat-page-header h1 {
  color: #111827 !important;
}

.chat-contact-meta-row b,
.chat-contact-meta-row span,
.conversation-meta,
.conversation-card-bottom p {
  color: #64748b !important;
}

.chat-modal label,
.chat-modal-tabs label,
.predefined-message-toggle span {
  color: #94a3b8 !important;
  font-weight: 500 !important;
}

.chat-filter-card label,
.filter-search-label {
  color: #475569 !important;
  font-weight: 500 !important;
}

.tags-modal {
  padding: 22px;
  background: radial-gradient(circle at top right, rgba(191, 219, 254, 0.34), transparent 48%), #ffffff;
}

.tags-modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 16px;
}

.tags-modal-header h2 {
  margin: 0;
  color: #1e293b;
  font-size: 28px;
  line-height: 1.15;
  font-weight: 700;
}

.tags-modal-header p {
  margin: 7px 0 0;
  color: #64748b;
  font-size: 13px;
  font-weight: 500;
}

.tags-modal-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border: 1px solid #dbe3ee;
  border-radius: 11px;
  background: #ffffff;
  color: #64748b;
  transition: all 0.2s ease;
}

.tags-modal-close:hover {
  background: #eff6ff;
  color: #2563eb;
  border-color: #bfdbfe;
}

.tags-modal-list {
  display: flex;
  flex-wrap: wrap;
  gap: 9px;
}

.tags-modal-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #93c5fd;
  border-radius: 999px;
  padding: 7px 13px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 700;
  box-shadow: 0 7px 16px rgba(37, 99, 235, 0.1);
}

.tags-modal-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 8px;
  min-height: 120px;
  border: 1px dashed #cbd5e1;
  border-radius: 16px;
  background: #f8fafc;
  color: #64748b;
  text-align: center;
  padding: 16px;
}

.tags-modal-empty p {
  margin: 0;
  font-size: 13px;
  font-weight: 500;
}

@media (max-width: 767px) {
  .chat-page {
    background: #f3f4f6;
  }

  .chat-stat-card {
    box-shadow: none;
  }
}
</style>
